"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
const constants = require("./constants");
const constants_1 = require("./constants");
const AndOptions_1 = require("./inputs/AndOptions");
const Aridor_1 = require("./cards/colonies/Aridor");
const Board_1 = require("./boards/Board");
const CardFinder_1 = require("./CardFinder");
const CardName_1 = require("./CardName");
const CardType_1 = require("./cards/CardType");
const ColonyName_1 = require("./colonies/ColonyName");
const LogMessageDataType_1 = require("./LogMessageDataType");
const MiningCard_1 = require("./cards/base/MiningCard");
const OrOptions_1 = require("./inputs/OrOptions");
const PartyHooks_1 = require("./turmoil/parties/PartyHooks");
const PartyName_1 = require("./turmoil/parties/PartyName");
const PharmacyUnion_1 = require("./cards/promo/PharmacyUnion");
const Phase_1 = require("./Phase");
const PlayerInput_1 = require("./PlayerInput");
const ResourceType_1 = require("./ResourceType");
const Resources_1 = require("./Resources");
const SelectAmount_1 = require("./inputs/SelectAmount");
const SelectCard_1 = require("./inputs/SelectCard");
const SellPatentsStandardProject_1 = require("./cards/base/standardProjects/SellPatentsStandardProject");
const SendDelegateToArea_1 = require("./deferredActions/SendDelegateToArea");
const DeferredAction_1 = require("./deferredActions/DeferredAction");
const SelectHowToPayDeferred_1 = require("./deferredActions/SelectHowToPayDeferred");
const SelectColony_1 = require("./inputs/SelectColony");
const SelectPartyToSendDelegate_1 = require("./inputs/SelectPartyToSendDelegate");
const SelectDelegate_1 = require("./inputs/SelectDelegate");
const SelectHowToPay_1 = require("./inputs/SelectHowToPay");
const SelectHowToPayForProjectCard_1 = require("./inputs/SelectHowToPayForProjectCard");
const SelectOption_1 = require("./inputs/SelectOption");
const SelectPlayer_1 = require("./inputs/SelectPlayer");
const SelectSpace_1 = require("./inputs/SelectSpace");
const SelfReplicatingRobots_1 = require("./cards/promo/SelfReplicatingRobots");
const SpaceType_1 = require("./SpaceType");
const Tags_1 = require("./cards/Tags");
const TileType_1 = require("./TileType");
const VictoryPointsBreakdown_1 = require("./VictoryPointsBreakdown");
const SelectProductionToLose_1 = require("./inputs/SelectProductionToLose");
const ShiftAresGlobalParameters_1 = require("./inputs/ShiftAresGlobalParameters");
const Timer_1 = require("./Timer");
const TurmoilHandler_1 = require("./turmoil/TurmoilHandler");
const TurmoilPolicy_1 = require("./turmoil/TurmoilPolicy");
const CardLoader_1 = require("./CardLoader");
const DrawCards_1 = require("./deferredActions/DrawCards");
const Units_1 = require("./Units");
const MoonExpansion_1 = require("./moon/MoonExpansion");
const ConvertPlants_1 = require("./cards/base/standardActions/ConvertPlants");
const ConvertPlantsEcoline_1 = require("./cards/base/standardActions/ConvertPlantsEcoline");
const ConvertHeat_1 = require("./cards/base/standardActions/ConvertHeat");
const Manutech_1 = require("./cards/venusNext/Manutech");
const LunaProjectOffice_1 = require("./cards/moon/LunaProjectOffice");
const UnitedNationsMissionOne_1 = require("./cards/community/corporations/UnitedNationsMissionOne");
const SilverCubeHandler_1 = require("./community/SilverCubeHandler");
const MonsInsurance_1 = require("./cards/promo/MonsInsurance");
const LogHelper_1 = require("./LogHelper");
const UndoActionOption_1 = require("./inputs/UndoActionOption");
const LawSuit_1 = require("./cards/promo/LawSuit");
const CrashSiteCleanup_1 = require("./cards/promo/CrashSiteCleanup");
const MarsCoalition_1 = require("./cards/community/corporations/MarsCoalition");
const Monument_1 = require("./milestones/fanmade/Monument");
const Awards_1 = require("./awards/Awards");
const TopsoilContract_1 = require("./cards/promo/TopsoilContract");
const MeatIndustry_1 = require("./cards/promo/MeatIndustry");
const Turmoil_1 = require("./turmoil/Turmoil");
const LeadersExpansion_1 = require("./cards/leaders/LeadersExpansion");
const VanAllen_1 = require("./cards/leaders/VanAllen");
const Eris_1 = require("./cards/ares/Eris");
const RedsPolicy_1 = require("./turmoil/RedsPolicy");
const KelvinistsDefaultAction_1 = require("./cards/turmoil/standardActions/KelvinistsDefaultAction");
const KelvinistsPolicy3Action_1 = require("./cards/turmoil/standardActions/KelvinistsPolicy3Action");
const ScientistsDefaultAction_1 = require("./cards/turmoil/standardActions/ScientistsDefaultAction");
const GreensPolicy4Action_1 = require("./cards/turmoil/standardActions/GreensPolicy4Action");
const MarsFirstPolicy4Action_1 = require("./cards/turmoil/standardActions/MarsFirstPolicy4Action");
const UnityPolicy2Action_1 = require("./cards/turmoil/standardActions/UnityPolicy2Action");
const UnityPolicy3Action_1 = require("./cards/turmoil/standardActions/UnityPolicy3Action");
const RedsPolicy3Action_1 = require("./cards/turmoil/standardActions/RedsPolicy3Action");
const SpomePolicy2Action_1 = require("./cards/turmoil/standardActions/SpomePolicy2Action");
const SpomePolicy4Action_1 = require("./cards/turmoil/standardActions/SpomePolicy4Action");
const EmpowerDefaultAction_1 = require("./cards/turmoil/standardActions/EmpowerDefaultAction");
const BureaucratsDefaultAction_1 = require("./cards/turmoil/standardActions/BureaucratsDefaultAction");
const BureaucratsPolicy3Action_1 = require("./cards/turmoil/standardActions/BureaucratsPolicy3Action");
const PopulistsPolicy3Action_1 = require("./cards/turmoil/standardActions/PopulistsPolicy3Action");
const TranshumansPolicy2Action_1 = require("./cards/turmoil/standardActions/TranshumansPolicy2Action");
const TranshumansPolicy3Action_1 = require("./cards/turmoil/standardActions/TranshumansPolicy3Action");
const CentristsDefaultAction_1 = require("./cards/turmoil/standardActions/CentristsDefaultAction");
const CentristsPolicy3Action_1 = require("./cards/turmoil/standardActions/CentristsPolicy3Action");
const Supercapacitors_1 = require("./cards/promo/Supercapacitors");
const Card_1 = require("./cards/Card");
const TerraformingDeal_1 = require("./cards/preludeTwo/TerraformingDeal");
const Briber_1 = require("./milestones/preludeTwo/Briber");
const MainBeltAsteroids_1 = require("./cards/preludeTwo/MainBeltAsteroids");
class Player {
    constructor(name, color, beginner, handicap = 0, id) {
        this.name = name;
        this.color = color;
        this.beginner = beginner;
        this.handicap = handicap;
        this.password = undefined;
        this._game = undefined;
        this.corporationCards = [];
        this.pickedCorporationCard = undefined;
        this.terraformRating = 20;
        this.hasIncreasedTerraformRatingThisGeneration = false;
        this.terraformRatingAtGenerationStart = 20;
        this.megaCredits = 0;
        this.megaCreditProduction = 0;
        this.steel = 0;
        this.steelProduction = 0;
        this.titanium = 0;
        this.titaniumProduction = 0;
        this.plants = 0;
        this.plantProduction = 0;
        this.energy = 0;
        this.energyProduction = 0;
        this.heat = 0;
        this.heatProduction = 0;
        this.titaniumValue = 3;
        this.steelValue = 2;
        this.canUseHeatAsMegaCredits = false;
        this.actionsTakenThisRound = 0;
        this.actionsThisGeneration = new Set();
        this.pendingInitialActions = [];
        this.remainingStallActionsCount = 2;
        this.canUndoLastAction = true;
        this.dealtCorporationCards = [];
        this.dealtProjectCards = [];
        this.dealtPreludeCards = [];
        this.dealtLeaderCards = [];
        this.cardsInHand = [];
        this.preludeCardsInHand = [];
        this.leaderCardsInHand = [];
        this.playedCards = [];
        this.draftedCards = [];
        this.cardCost = constants.CARD_COST;
        this.needsToDraft = undefined;
        this.cardDiscount = 0;
        this.timer = Timer_1.Timer.newInstance();
        this.hasConceded = false;
        this.fleetSize = 1;
        this.tradesThisGeneration = 0;
        this.hasTradedThisTurn = false;
        this.colonyTradeOffset = 0;
        this.colonyTradeDiscount = 0;
        this.colonyVictoryPoints = 0;
        this.hasBureaucratsColonyTradePenalty = false;
        this.hasTranshumansColonyTradeOffset = false;
        this.turmoilPolicyActionUsed = false;
        this.politicalAgendasActionUsedCount = 0;
        this.dominantPartyActionUsedCount = 0;
        this.victoryPointsBreakdown = new VictoryPointsBreakdown_1.VictoryPointsBreakdown();
        this.oceanBonus = constants.OCEAN_BONUS;
        this.hasTurmoilScienceTagBonus = false;
        this.scienceTagCount = 0;
        this.plantsNeededForGreenery = 8;
        this.removingPlayers = [];
        this.removedFromPlayCards = [];
        this.heatProductionStepsIncreasedThisGeneration = 0;
        this.consecutiveFirstPassCount = 0;
        this.requirementsBonus = 0;
        this.hasUsedHeadStart = false;
        this.hazardsRemoved = 0;
        this.oceansPlaced = 0;
        this.preservationProgramActive = false;
        this.suitableInfrastructureActive = false;
        this.temperatureStepsRaised = 0;
        this.totalSpend = 0;
        this.endGenerationScores = [];
        this.actionsTakenThisGame = 0;
        this.totalDelegatesPlaced = 0;
        this.totalChairmanshipsWon = 0;
        this.id = id;
    }
    static initialize(name, color, beginner, handicap = 0, id) {
        const player = new Player(name, color, beginner, handicap, id);
        return player;
    }
    set game(game) {
        if (this._game !== undefined) {
            console.warn(`Reinitializing game ${game.id} for player ${this.color}`);
        }
        this._game = game;
    }
    get game() {
        if (this._game === undefined) {
            throw new Error(`Fetching game for player ${this.color} too soon.`);
        }
        return this._game;
    }
    isCorporation(corporationName) {
        return this.corporationCards.some((corp) => corp.name === corporationName);
    }
    getTitaniumValue() {
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.UNITY))
            return this.titaniumValue + 1;
        if (MarsCoalition_1.MarsCoalition.shouldIncreaseMetalValue(this, PartyName_1.PartyName.UNITY))
            return this.titaniumValue + 1;
        return this.titaniumValue;
    }
    increaseTitaniumValue() {
        this.titaniumValue++;
    }
    decreaseTitaniumValue() {
        if (this.titaniumValue > constants.DEFAULT_TITANIUM_VALUE) {
            this.titaniumValue--;
        }
    }
    getSelfReplicatingRobotsTargetCards() {
        var _a, _b;
        return (_b = (_a = this.playedCards.find((card) => card instanceof SelfReplicatingRobots_1.SelfReplicatingRobots)) === null || _a === void 0 ? void 0 : _a.targetCards) !== null && _b !== void 0 ? _b : [];
    }
    getSteelValue() {
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.MARS, TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_POLICY_3))
            return this.steelValue + 1;
        if (MarsCoalition_1.MarsCoalition.shouldIncreaseMetalValue(this, PartyName_1.PartyName.MARS, TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_POLICY_3))
            return this.steelValue + 1;
        return this.steelValue;
    }
    increaseSteelValue() {
        this.steelValue++;
    }
    decreaseSteelValue() {
        if (this.steelValue > constants.DEFAULT_STEEL_VALUE) {
            this.steelValue--;
        }
    }
    getTerraformRating() {
        return this.terraformRating;
    }
    decreaseTerraformRating(log = false) {
        this.terraformRating--;
        if (log)
            LogHelper_1.LogHelper.logGlobalEventTRDecrease(this);
    }
    increaseTerraformRating() {
        UnitedNationsMissionOne_1.UnitedNationsMissionOne.onTRIncrease(this.game);
        TerraformingDeal_1.TerraformingDeal.onTRIncrease(this);
        if (this.game.phase === Phase_1.Phase.ACTION && this.preservationProgramActive === true) {
            this.preservationProgramActive = false;
            return;
        }
        if (!this.game.gameOptions.turmoilExtension || this.cardIsInEffect(CardName_1.CardName.ZAN)) {
            this.terraformRating++;
            this.hasIncreasedTerraformRatingThisGeneration = true;
            return;
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.REDS)) {
            if (this.canAfford(constants_1.REDS_RULING_POLICY_COST)) {
                this.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(this, constants_1.REDS_RULING_POLICY_COST, { title: 'Select how to pay for TR increase' }));
            }
            else {
                return;
            }
        }
        this.terraformRating++;
        this.hasIncreasedTerraformRatingThisGeneration = true;
    }
    increaseTerraformRatingSteps(value) {
        for (let i = 0; i < value; i++) {
            this.increaseTerraformRating();
        }
        if (this.cardIsInEffect(CardName_1.CardName.GRETA)) {
            const greta = this.playedCards.find((card) => card.name === CardName_1.CardName.GRETA);
            greta.onTRIncrease(this);
        }
    }
    decreaseTerraformRatingSteps(value, log = false) {
        this.terraformRating -= value;
        if (log)
            LogHelper_1.LogHelper.logGlobalEventTRDecrease(this, value);
    }
    setTerraformRating(value) {
        return this.terraformRating = value;
    }
    getAvailableProductionUnits() {
        return (this.getProduction(Resources_1.Resources.MEGACREDITS) + 5) +
            this.getProduction(Resources_1.Resources.STEEL) +
            this.getProduction(Resources_1.Resources.TITANIUM) +
            this.getProduction(Resources_1.Resources.PLANTS) +
            this.getProduction(Resources_1.Resources.ENERGY) +
            this.getProduction(Resources_1.Resources.HEAT);
    }
    getProduction(resource) {
        if (resource === Resources_1.Resources.MEGACREDITS)
            return this.megaCreditProduction;
        if (resource === Resources_1.Resources.STEEL)
            return this.steelProduction;
        if (resource === Resources_1.Resources.TITANIUM)
            return this.titaniumProduction;
        if (resource === Resources_1.Resources.PLANTS)
            return this.plantProduction;
        if (resource === Resources_1.Resources.ENERGY)
            return this.energyProduction;
        if (resource === Resources_1.Resources.HEAT)
            return this.heatProduction;
        throw new Error('Resource ' + resource + ' not found');
    }
    getResource(resource) {
        if (resource === Resources_1.Resources.MEGACREDITS)
            return this.megaCredits;
        if (resource === Resources_1.Resources.STEEL)
            return this.steel;
        if (resource === Resources_1.Resources.TITANIUM)
            return this.titanium;
        if (resource === Resources_1.Resources.PLANTS)
            return this.plants;
        if (resource === Resources_1.Resources.ENERGY)
            return this.energy;
        if (resource === Resources_1.Resources.HEAT)
            return this.heat;
        throw new Error('Resource ' + resource + ' not found');
    }
    logUnitDelta(resource, amount, unitType, from, stealing = false) {
        if (amount === 0)
            return;
        const modifier = amount > 0 ? 'increased' : 'decreased';
        const absAmount = Math.abs(amount);
        let message = '${0}\'s ${1} ' + unitType + ' ${2} by ${3}';
        if (from !== undefined) {
            if (stealing === true)
                message = message + ' stolen';
            message = message + ' by ' + ((from instanceof Player) ? '${4}' : 'Global Event');
        }
        this.game.log(message, (b) => {
            b.player(this)
                .string(resource)
                .string(modifier)
                .number(absAmount);
            if (from instanceof Player) {
                b.player(from);
            }
        });
    }
    deductResource(resource, amount, options) {
        const shouldApplyBentenmaruEffect = (options === null || options === void 0 ? void 0 : options.from) !== undefined && options.from instanceof Player && options.from.isCorporation(CardName_1.CardName.BENTENMARU) && options.from.id !== this.id;
        if (shouldApplyBentenmaruEffect) {
            const bentenmaruPlayer = options.from;
            bentenmaruPlayer.addResource(resource, amount, options);
        }
        else {
            this.addResource(resource, -amount, options);
        }
    }
    addResource(resource, amount = 1, options) {
        const playerAmount = this.getResource(resource);
        const delta = (amount >= 0) ? amount : Math.max(amount, -playerAmount);
        if (delta !== amount && (options === null || options === void 0 ? void 0 : options.from) === undefined) {
            this.game.logIllegalState(`Adjusting ${amount} ${resource} when player has ${playerAmount}`, { player: { color: this.color, id: this.id, name: this.name }, resource, amount });
        }
        if (resource === Resources_1.Resources.MEGACREDITS)
            this.megaCredits += delta;
        else if (resource === Resources_1.Resources.STEEL)
            this.steel += delta;
        else if (resource === Resources_1.Resources.TITANIUM)
            this.titanium += delta;
        else if (resource === Resources_1.Resources.PLANTS)
            this.plants += delta;
        else if (resource === Resources_1.Resources.ENERGY)
            this.energy += delta;
        else if (resource === Resources_1.Resources.HEAT)
            this.heat += delta;
        else {
            throw new Error(`tried to add unsupported resource ${resource}`);
        }
        if ((options === null || options === void 0 ? void 0 : options.log) === true) {
            this.logUnitDelta(resource, delta, 'amount', options.from, options.stealing);
        }
        if ((options === null || options === void 0 ? void 0 : options.from) instanceof Player) {
            LawSuit_1.LawSuit.resourceHook(this, resource, delta, options.from);
            CrashSiteCleanup_1.CrashSiteCleanup.resourceHook(this, resource, delta, options.from);
        }
        if ((options === null || options === void 0 ? void 0 : options.from) !== undefined && delta < 0 && (options.from instanceof Player && options.from.id !== this.id)) {
            MonsInsurance_1.MonsInsurance.resolveMonsInsurance(this);
        }
    }
    addProduction(resource, amount = 1, options) {
        const adj = resource === Resources_1.Resources.MEGACREDITS ? -5 : 0;
        const delta = (amount >= 0) ? amount : Math.max(amount, -(this.getProduction(resource) - adj));
        const shouldApplyBentenmaruEffect = delta < 0 && (options === null || options === void 0 ? void 0 : options.from) !== undefined && options.from instanceof Player && options.from.isCorporation(CardName_1.CardName.BENTENMARU) && options.from.id !== this.id;
        if (amount > 0 && this.suitableInfrastructureActive === true && this.game.activePlayer === this.id && this.game.phase === Phase_1.Phase.ACTION) {
            this.suitableInfrastructureActive = false;
            this.addResource(Resources_1.Resources.MEGACREDITS, 2);
            this.game.log('${0} gained 2 megacredits from ${1} effect', (b) => b.player(this).cardName(CardName_1.CardName.SUITABLE_INFRASTRUCTURE));
        }
        if (resource === Resources_1.Resources.MEGACREDITS) {
            if (shouldApplyBentenmaruEffect) {
                options.from.addProduction(Resources_1.Resources.MEGACREDITS, Math.abs(delta));
            }
            else {
                this.megaCreditProduction += delta;
            }
        }
        else if (resource === Resources_1.Resources.STEEL) {
            if (shouldApplyBentenmaruEffect) {
                options.from.addProduction(Resources_1.Resources.STEEL, Math.abs(delta));
            }
            else {
                this.steelProduction += delta;
            }
        }
        else if (resource === Resources_1.Resources.TITANIUM) {
            if (shouldApplyBentenmaruEffect) {
                options.from.addProduction(Resources_1.Resources.TITANIUM, Math.abs(delta));
            }
            else {
                this.titaniumProduction += delta;
            }
        }
        else if (resource === Resources_1.Resources.PLANTS) {
            if (shouldApplyBentenmaruEffect) {
                options.from.addProduction(Resources_1.Resources.PLANTS, Math.abs(delta));
            }
            else {
                this.plantProduction += delta;
            }
        }
        else if (resource === Resources_1.Resources.ENERGY) {
            const shouldGrantBonusEnergy = PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.EMPOWER, TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_3);
            if (shouldApplyBentenmaruEffect) {
                options.from.addProduction(Resources_1.Resources.ENERGY, Math.abs(delta));
                if (shouldGrantBonusEnergy)
                    options.from.addResource(Resources_1.Resources.ENERGY, 2);
            }
            else {
                this.energyProduction += delta;
                if (shouldGrantBonusEnergy)
                    this.addResource(Resources_1.Resources.ENERGY, 2);
            }
        }
        else if (resource === Resources_1.Resources.HEAT) {
            if (shouldApplyBentenmaruEffect) {
                const bentenmaruPlayer = options.from;
                const heatProdGained = Math.abs(delta);
                bentenmaruPlayer.addProduction(Resources_1.Resources.HEAT, heatProdGained);
                if (heatProdGained > 0)
                    bentenmaruPlayer.heatProductionStepsIncreasedThisGeneration += amount;
            }
            else {
                this.heatProduction += delta;
                if (amount > 0)
                    this.heatProductionStepsIncreasedThisGeneration += amount;
            }
        }
        else {
            throw new Error(`tried to add unsupported production ${resource}`);
        }
        if ((options === null || options === void 0 ? void 0 : options.log) === true) {
            this.logUnitDelta(resource, amount, 'production', options.from);
        }
        if ((options === null || options === void 0 ? void 0 : options.from) instanceof Player) {
            LawSuit_1.LawSuit.resourceHook(this, resource, delta, options.from);
        }
        if ((options === null || options === void 0 ? void 0 : options.from) !== undefined && delta < 0 && (options.from instanceof Player && options.from.id !== this.id)) {
            MonsInsurance_1.MonsInsurance.resolveMonsInsurance(this);
        }
        if (this.isCorporation(CardName_1.CardName.MANUTECH)) {
            Manutech_1.Manutech.onProductionGain(this, resource, amount);
        }
    }
    ;
    stealResource(resource, qty, thief) {
        const qtyToSteal = Math.min(this.getResource(resource), qty);
        if (qtyToSteal > 0) {
            this.deductResource(resource, qtyToSteal, { log: true, from: thief, stealing: true });
            thief.addResource(resource, qtyToSteal);
        }
    }
    hasUnits(units) {
        return this.megaCredits - units.megacredits >= 0 &&
            this.steel - units.steel >= 0 &&
            this.titanium - units.titanium >= 0 &&
            this.plants - units.plants >= 0 &&
            this.energy - units.energy >= 0 &&
            this.heat - units.heat >= 0;
    }
    addUnits(units, options) {
        this.addResource(Resources_1.Resources.MEGACREDITS, units.megacredits || 0, options);
        this.addResource(Resources_1.Resources.STEEL, units.steel || 0, options);
        this.addResource(Resources_1.Resources.TITANIUM, units.titanium || 0, options);
        this.addResource(Resources_1.Resources.PLANTS, units.plants || 0, options);
        this.addResource(Resources_1.Resources.ENERGY, units.energy || 0, options);
        this.addResource(Resources_1.Resources.HEAT, units.heat || 0, options);
    }
    deductUnits(units) {
        this.megaCredits -= units.megacredits;
        this.steel -= units.steel;
        this.titanium -= units.titanium;
        this.plants -= units.plants;
        this.energy -= units.energy;
        this.heat -= units.heat;
    }
    canAdjustProduction(units) {
        return this.getProduction(Resources_1.Resources.MEGACREDITS) + units.megacredits >= -5 &&
            this.getProduction(Resources_1.Resources.STEEL) + units.steel >= 0 &&
            this.getProduction(Resources_1.Resources.TITANIUM) + units.titanium >= 0 &&
            this.getProduction(Resources_1.Resources.PLANTS) + units.plants >= 0 &&
            this.getProduction(Resources_1.Resources.ENERGY) + units.energy >= 0 &&
            this.getProduction(Resources_1.Resources.HEAT) + units.heat >= 0;
    }
    adjustProduction(units, options) {
        if (units.megacredits !== undefined) {
            this.addProduction(Resources_1.Resources.MEGACREDITS, units.megacredits, options);
        }
        if (units.steel !== undefined) {
            this.addProduction(Resources_1.Resources.STEEL, units.steel, options);
        }
        if (units.titanium !== undefined) {
            this.addProduction(Resources_1.Resources.TITANIUM, units.titanium, options);
        }
        if (units.plants !== undefined) {
            this.addProduction(Resources_1.Resources.PLANTS, units.plants, options);
        }
        if (units.energy !== undefined) {
            this.addProduction(Resources_1.Resources.ENERGY, units.energy, options);
        }
        if (units.heat !== undefined) {
            this.addProduction(Resources_1.Resources.HEAT, units.heat, options);
        }
    }
    getActionsThisGeneration() {
        return this.actionsThisGeneration;
    }
    setActionsThisGeneration(cardName) {
        this.actionsThisGeneration.add(cardName);
        return;
    }
    getVictoryPoints() {
        var _a;
        const victoryPointsBreakdown = new VictoryPointsBreakdown_1.VictoryPointsBreakdown();
        this.corporationCards.forEach((corp) => {
            if (corp.getVictoryPoints !== undefined) {
                victoryPointsBreakdown.setVictoryPoints('victoryPoints', corp.getVictoryPoints(this), corp.name);
            }
        });
        for (const playedCard of this.playedCards) {
            if (playedCard.getVictoryPoints !== undefined) {
                victoryPointsBreakdown.setVictoryPoints('victoryPoints', playedCard.getVictoryPoints(this), playedCard.name);
            }
        }
        const verminOwner = this.game.getPlayers().find((player) => player.cardIsInEffect(CardName_1.CardName.VERMIN));
        if (verminOwner !== undefined) {
            const vermin = verminOwner.playedCards.find((card) => card.name === CardName_1.CardName.VERMIN);
            if (vermin.resourceCount >= 10) {
                victoryPointsBreakdown.setVictoryPoints('victoryPoints', -1 * this.getCitiesCount(), vermin.name);
            }
        }
        victoryPointsBreakdown.setVictoryPoints('terraformRating', this.terraformRating);
        Awards_1.Awards.giveAwards(this, victoryPointsBreakdown);
        for (const milestone of this.game.claimedMilestones) {
            if (milestone.player !== undefined && milestone.player.id === this.id) {
                victoryPointsBreakdown.setVictoryPoints('milestones', constants.MILESTONE_VP, 'Claimed ' + milestone.milestone.name + ' milestone');
            }
        }
        this.game.board.spaces.forEach((space) => {
            if (space.tile && space.tile.tileType === TileType_1.TileType.GREENERY && space.player !== undefined && space.player.id === this.id) {
                victoryPointsBreakdown.setVictoryPoints('greenery', 1);
            }
            if (Board_1.Board.isCitySpace(space) && space.player !== undefined && space.player.id === this.id) {
                const adjacent = this.game.board.getAdjacentSpaces(space);
                for (const adj of adjacent) {
                    if (adj.tile && adj.tile.tileType === TileType_1.TileType.GREENERY) {
                        victoryPointsBreakdown.setVictoryPoints('city', 1);
                    }
                }
            }
        });
        const includeTurmoilVP = this.game.gameIsOver() || this.game.phase === Phase_1.Phase.END;
        Turmoil_1.Turmoil.ifTurmoil(this.game, (turmoil) => {
            if (includeTurmoilVP) {
                victoryPointsBreakdown.setVictoryPoints('victoryPoints', turmoil.getPlayerVictoryPoints(this), 'Turmoil Points');
            }
        });
        if (this.colonyVictoryPoints > 0) {
            victoryPointsBreakdown.setVictoryPoints('victoryPoints', this.colonyVictoryPoints, 'Colony VP');
        }
        MoonExpansion_1.MoonExpansion.calculateVictoryPoints(this, victoryPointsBreakdown);
        if (this.game.gameOptions.escapeVelocityMode) {
            const threshold = this.game.gameOptions.escapeVelocityThreshold;
            const period = this.game.gameOptions.escapeVelocityPeriod;
            const penaltyPerMin = (_a = this.game.gameOptions.escapeVelocityPenalty) !== null && _a !== void 0 ? _a : 1;
            const elapsedTimeInMinutes = this.timer.getElapsedTimeInMinutes();
            if (threshold !== undefined && period !== undefined && elapsedTimeInMinutes > threshold) {
                const overTimeInMinutes = Math.max(elapsedTimeInMinutes - threshold, 0);
                victoryPointsBreakdown.updateTotal();
                const totalBeforeEscapeVelocity = victoryPointsBreakdown.total;
                const penaltyTotal = Math.min(penaltyPerMin * Math.floor(overTimeInMinutes / period), totalBeforeEscapeVelocity);
                victoryPointsBreakdown.setVictoryPoints('escapeVelocity penalty', -penaltyTotal, 'Escape Velocity Penalty');
            }
        }
        victoryPointsBreakdown.updateTotal();
        return victoryPointsBreakdown;
    }
    cardIsInEffect(cardName) {
        return this.playedCards.find((playedCard) => playedCard.name === cardName) !== undefined;
    }
    hasProtectedHabitats() {
        return this.cardIsInEffect(CardName_1.CardName.PROTECTED_HABITATS);
    }
    plantsAreProtected() {
        return this.hasProtectedHabitats() || this.cardIsInEffect(CardName_1.CardName.ASTEROID_DEFLECTION_SYSTEM);
    }
    alloysAreProtected() {
        return this.cardIsInEffect(CardName_1.CardName.LUNAR_SECURITY_STATIONS);
    }
    getCitiesCount() {
        const board = this.game.board;
        return board.getSpaceCount(TileType_1.TileType.CITY, this) +
            board.getSpaceCount(TileType_1.TileType.CAPITAL, this) +
            board.getSpaceCount(TileType_1.TileType.OCEAN_CITY, this) +
            board.getSpaceCount(TileType_1.TileType.NEW_HOLLAND, this);
    }
    getNoTagsCount() {
        let noTagsCount = 0;
        this.corporationCards.filter((c) => c.name !== CardName_1.CardName.PHARMACY_UNION).forEach((corp) => {
            if (corp.tags.filter((tag) => tag !== Tags_1.Tags.WILDCARD).length === 0) {
                noTagsCount++;
            }
        });
        noTagsCount += this.playedCards.filter((card) => card.cardType !== CardType_1.CardType.EVENT && card.tags.filter((tag) => tag !== Tags_1.Tags.WILDCARD).length === 0).length;
        return noTagsCount;
    }
    getColoniesCount() {
        if (!this.game.gameOptions.coloniesExtension)
            return 0;
        let coloniesCount = 0;
        this.game.colonies.forEach((colony) => {
            coloniesCount += colony.colonies.filter((owner) => owner === this.id).length;
        });
        return coloniesCount;
    }
    getPlayedEventsCount() {
        let count = this.playedCards.filter((card) => card.cardType === CardType_1.CardType.EVENT).length;
        if (this.isCorporation(CardName_1.CardName.PHARMACY_UNION)) {
            const pharmacyUnion = this.corporationCards.find((corp) => corp.name === CardName_1.CardName.PHARMACY_UNION);
            if (pharmacyUnion === null || pharmacyUnion === void 0 ? void 0 : pharmacyUnion.isDisabled)
                count++;
        }
        return count;
    }
    getResourcesOnCard(card) {
        if (card.resourceCount !== undefined) {
            return card.resourceCount;
        }
        else
            return undefined;
    }
    getRequirementsBonus(parameter) {
        let requirementsBonus = this.requirementsBonus;
        this.corporationCards.forEach((corp) => {
            if (corp.getRequirementBonus !== undefined) {
                requirementsBonus += corp.getRequirementBonus(this, parameter);
            }
        });
        for (const playedCard of this.playedCards) {
            if (playedCard.getRequirementBonus !== undefined &&
                playedCard.getRequirementBonus(this, parameter)) {
                requirementsBonus += playedCard.getRequirementBonus(this, parameter);
            }
        }
        const lastRemovedFromPlayCard = this.removedFromPlayCards[this.removedFromPlayCards.length - 1];
        if (lastRemovedFromPlayCard !== undefined && lastRemovedFromPlayCard.name === CardName_1.CardName.SPECIAL_DESIGN) {
            requirementsBonus += 2;
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.SCIENTISTS, TurmoilPolicy_1.TurmoilPolicy.SCIENTISTS_POLICY_2)) {
            requirementsBonus += 2;
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.TRANSHUMANS, TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_3) && this.turmoilPolicyActionUsed === true) {
            requirementsBonus += 50;
        }
        requirementsBonus = MarsCoalition_1.MarsCoalition.getRequirementsBonus(this, requirementsBonus);
        return requirementsBonus;
    }
    removeResourceFrom(card, count = 1, game, removingPlayer, shouldLogAction = true) {
        if (card.resourceCount) {
            card.resourceCount = Math.max(card.resourceCount - count, 0);
            if (game !== undefined && removingPlayer !== undefined) {
                if (removingPlayer !== this)
                    MonsInsurance_1.MonsInsurance.resolveMonsInsurance(this);
                if (shouldLogAction) {
                    game.log('${0} removed ${1} resource(s) from ${2}\'s ${3}', (b) => b.player(removingPlayer)
                        .number(count)
                        .player(this)
                        .card(card));
                }
            }
            if (removingPlayer !== undefined && removingPlayer !== this && this.removingPlayers.includes(removingPlayer.id) === false) {
                this.removingPlayers.push(removingPlayer.id);
            }
        }
    }
    addResourceTo(card, options = 1) {
        var _a;
        const count = typeof (options) === 'number' ? options : ((_a = options.qty) !== null && _a !== void 0 ? _a : 1);
        if (card.resourceCount !== undefined)
            card.resourceCount += count;
        TopsoilContract_1.TopsoilContract.onResourceAdded(this, card, count);
        MeatIndustry_1.MeatIndustry.onResourceAdded(this, card, count);
        MainBeltAsteroids_1.MainBeltAsteroids.onResourceAdded(this, card, count);
        if (typeof (options) !== 'number' && options.log === true && count > 0) {
            LogHelper_1.LogHelper.logAddResource(this, card, count);
        }
    }
    getCardsWithResources(resource) {
        let result = this.playedCards.filter((card) => card.resourceType !== undefined && card.resourceCount && card.resourceCount > 0);
        this.corporationCards.forEach((corp) => {
            if (corp.resourceType !== undefined && corp.resourceCount !== undefined && corp.resourceCount > 0) {
                result.push(corp);
            }
        });
        if (resource !== undefined) {
            result = result.filter((card) => card.resourceType === resource);
        }
        return result;
    }
    getResourceCards(resource = undefined) {
        let result = this.playedCards.filter((card) => card.resourceType !== undefined);
        this.corporationCards.forEach((corp) => {
            if (corp.resourceType !== undefined && !corp.isDisabled)
                result.push(corp);
        });
        if (resource !== undefined) {
            result = result.filter((card) => card.resourceType === resource);
        }
        return result;
    }
    getResourceCount(resource) {
        let count = 0;
        this.getCardsWithResources(resource).forEach((card) => {
            count += this.getResourcesOnCard(card);
        });
        return count;
    }
    getCardsByCardType(cardType) {
        return this.playedCards.filter((card) => card.cardType === cardType);
    }
    getAllTags() {
        return [
            { tag: Tags_1.Tags.BUILDING, count: this.getTagCount(Tags_1.Tags.BUILDING, 'raw') },
            { tag: Tags_1.Tags.CITY, count: this.getTagCount(Tags_1.Tags.CITY, 'raw') },
            { tag: Tags_1.Tags.EARTH, count: this.getTagCount(Tags_1.Tags.EARTH, 'raw') },
            { tag: Tags_1.Tags.ENERGY, count: this.getTagCount(Tags_1.Tags.ENERGY, 'raw') },
            { tag: Tags_1.Tags.JOVIAN, count: this.getTagCount(Tags_1.Tags.JOVIAN, 'raw') },
            { tag: Tags_1.Tags.MICROBE, count: this.getTagCount(Tags_1.Tags.MICROBE, 'raw') },
            { tag: Tags_1.Tags.MOON, count: this.getTagCount(Tags_1.Tags.MOON, 'raw') },
            { tag: Tags_1.Tags.PLANT, count: this.getTagCount(Tags_1.Tags.PLANT, 'raw') },
            { tag: Tags_1.Tags.SCIENCE, count: this.getTagCount(Tags_1.Tags.SCIENCE, 'raw') },
            { tag: Tags_1.Tags.SPACE, count: this.getTagCount(Tags_1.Tags.SPACE, 'raw') },
            { tag: Tags_1.Tags.VENUS, count: this.getTagCount(Tags_1.Tags.VENUS, 'raw') },
            { tag: Tags_1.Tags.WILDCARD, count: this.getTagCount(Tags_1.Tags.WILDCARD, 'raw') },
            { tag: Tags_1.Tags.ANIMAL, count: this.getTagCount(Tags_1.Tags.ANIMAL, 'raw') },
            { tag: Tags_1.Tags.EVENT, count: this.getPlayedEventsCount() },
        ].filter((tag) => tag.count > 0);
    }
    getTagCount(tag, mode = 'default') {
        const includeTagSubstitutions = (mode === 'default' || mode === 'milestone');
        let tagCount = this.getRawTagCount(tag, false);
        if (tag === Tags_1.Tags.SCIENCE && this.scienceTagCount > 0) {
            tagCount += this.scienceTagCount;
        }
        if ((tag === Tags_1.Tags.WILDCARD || includeTagSubstitutions) && PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.TRANSHUMANS, TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_DEFAULT_POLICY)) {
            tagCount += 1;
        }
        if (tag === Tags_1.Tags.WILDCARD || includeTagSubstitutions) {
            tagCount += LeadersExpansion_1.LeadersExpansion.getBonusWildTags(this);
        }
        tagCount = MarsCoalition_1.MarsCoalition.checkBonusWildTag(this, tag, tagCount);
        if (includeTagSubstitutions) {
            if (tag === Tags_1.Tags.EARTH && this.cardIsInEffect(CardName_1.CardName.EARTH_EMBASSY)) {
                tagCount += this.getRawTagCount(Tags_1.Tags.MOON, false);
            }
            if (tag !== Tags_1.Tags.WILDCARD) {
                tagCount += this.getRawTagCount(Tags_1.Tags.WILDCARD, false);
            }
        }
        return tagCount;
    }
    getRawTagCount(tag, includeEventsTags) {
        let tagCount = 0;
        this.playedCards.forEach((card) => {
            if (!includeEventsTags && card.cardType === CardType_1.CardType.EVENT)
                return;
            tagCount += card.tags.filter((cardTag) => cardTag === tag).length;
        });
        this.corporationCards.forEach((corp) => {
            if (corp.tags.length > 0 && !corp.isDisabled) {
                tagCount += corp.tags.filter((cardTag) => cardTag === tag).length;
            }
        });
        return tagCount;
    }
    getMultipleTagCount(tags, _mode = 'default') {
        let tagCount = 0;
        tags.forEach((tag) => {
            tagCount += this.getRawTagCount(tag, false);
        });
        if (tags.includes(Tags_1.Tags.EARTH) && !tags.includes(Tags_1.Tags.MOON) && this.cardIsInEffect(CardName_1.CardName.EARTH_EMBASSY)) {
            tagCount += this.getRawTagCount(Tags_1.Tags.MOON, false);
        }
        tagCount += this.getRawTagCount(Tags_1.Tags.WILDCARD, false);
        tagCount += LeadersExpansion_1.LeadersExpansion.getBonusWildTags(this);
        return tagCount;
    }
    getDistinctTagCount(mode, extraTag) {
        let wildTagCount = LeadersExpansion_1.LeadersExpansion.getBonusWildTags(this);
        const uniqueTags = new Set();
        const addTag = (tag) => {
            if (tag === Tags_1.Tags.WILDCARD) {
                wildTagCount++;
            }
            else {
                uniqueTags.add(tag);
            }
        };
        if (extraTag !== undefined)
            uniqueTags.add(extraTag);
        for (const corp of this.corporationCards) {
            if (!corp.isDisabled) {
                corp.tags.forEach(addTag);
            }
        }
        for (const card of this.playedCards) {
            if (card.cardType !== CardType_1.CardType.EVENT) {
                card.tags.forEach(addTag);
            }
        }
        if (this.scienceTagCount > 0)
            uniqueTags.add(Tags_1.Tags.SCIENCE);
        if (mode === 'globalEvent')
            return uniqueTags.size;
        let maxTagCount = 10;
        if (this.game.gameOptions.venusNextExtension)
            maxTagCount++;
        if (this.game.gameOptions.moonExpansion)
            maxTagCount++;
        const total = uniqueTags.size + wildTagCount;
        return Math.min(total, maxTagCount);
    }
    checkMultipleTagPresence(tags) {
        let distinctCount = 0;
        tags.forEach((tag) => {
            if (this.getTagCount(tag, 'raw') > 0) {
                distinctCount++;
            }
            else if (tag === Tags_1.Tags.SCIENCE && this.hasTurmoilScienceTagBonus) {
                distinctCount++;
            }
        });
        if (distinctCount + this.getTagCount(Tags_1.Tags.WILDCARD) >= tags.length) {
            return true;
        }
        return false;
    }
    runInputCb(result) {
        if (result !== undefined) {
            this.defer(result, DeferredAction_1.Priority.DEFAULT);
        }
    }
    checkInputLength(input, length, firstOptionLength) {
        if (input.length !== length) {
            throw new Error('Incorrect options provided');
        }
        if (firstOptionLength !== undefined && input[0].length !== firstOptionLength) {
            throw new Error('Incorrect options provided (nested)');
        }
    }
    parseHowToPayJSON(json) {
        const defaults = {
            steel: 0,
            heat: 0,
            titanium: 0,
            megaCredits: 0,
            microbes: 0,
            floaters: 0,
            science: 0,
            graphene: 0,
            asteroids: 0,
            plants: 0,
            spireScience: 0,
        };
        try {
            const howToPay = JSON.parse(json);
            if (Object.keys(howToPay).every((key) => key in defaults) === false) {
                throw new Error('Input contains unauthorized keys');
            }
            return howToPay;
        }
        catch (err) {
            throw new Error('Unable to parse HowToPay input ' + err);
        }
    }
    runInput(input, pi) {
        var _a;
        if (pi instanceof AndOptions_1.AndOptions) {
            this.checkInputLength(input, pi.options.length);
            for (let i = 0; i < input.length; i++) {
                this.runInput([input[i]], pi.options[i]);
            }
            this.runInputCb(pi.cb());
        }
        else if (pi instanceof SelectAmount_1.SelectAmount) {
            this.checkInputLength(input, 1, 1);
            const amount = parseInt(input[0][0]);
            if (isNaN(amount)) {
                throw new Error('Number not provided for amount');
            }
            if (amount > pi.max) {
                throw new Error('Amount provided too high (max ' + String(pi.max) + ')');
            }
            if (amount < pi.min) {
                throw new Error('Amount provided too low (min ' + String(pi.min) + ')');
            }
            this.runInputCb(pi.cb(amount));
        }
        else if (pi instanceof SelectOption_1.SelectOption) {
            this.runInputCb(pi.cb());
        }
        else if (pi instanceof SelectColony_1.SelectColony) {
            this.checkInputLength(input, 1, 1);
            const colony = (input[0][0]);
            if (colony === undefined) {
                throw new Error('No colony selected');
            }
            this.runInputCb(pi.cb(colony));
        }
        else if (pi instanceof OrOptions_1.OrOptions) {
            if (input.length === 0 || input[0].length !== 1) {
                throw new Error('Incorrect options provided');
            }
            const optionIndex = parseInt(input[0][0]);
            const selectedOptionInput = input.slice(1);
            this.runInput(selectedOptionInput, pi.options[optionIndex]);
            this.runInputCb(pi.cb());
        }
        else if (pi instanceof SelectHowToPayForProjectCard_1.SelectHowToPayForProjectCard) {
            this.checkInputLength(input, 1, 2);
            const cardName = input[0][0];
            const _data = PlayerInput_1.PlayerInput.getCard(pi.cards, cardName);
            const foundCard = _data.card;
            const howToPay = this.parseHowToPayJSON(input[0][1]);
            const reserveUnits = pi.reserveUnits[_data.idx];
            if (reserveUnits.megacredits + howToPay.megaCredits > this.megaCredits) {
                throw new Error(`${reserveUnits.megacredits} M€ must be reserved for ${cardName}`);
            }
            if (reserveUnits.steel + howToPay.steel > this.steel) {
                throw new Error(`${reserveUnits.steel} units of steel must be reserved for ${cardName}`);
            }
            if (reserveUnits.titanium + howToPay.titanium > this.titanium) {
                throw new Error(`${reserveUnits.titanium} units of titanium must be reserved for ${cardName}`);
            }
            if (cardName === CardName_1.CardName.SOIL_ENRICHMENT) {
                const microbeCardsWithResources = this.getResourceCards(ResourceType_1.ResourceType.MICROBE).filter((c) => c.resourceCount > 0);
                if (microbeCardsWithResources.length === 1 && microbeCardsWithResources[0].name === CardName_1.CardName.PSYCHROPHILES) {
                    const availableMicrobes = this.getMicrobesCanSpend();
                    if (howToPay.microbes + 1 > availableMicrobes) {
                        throw new Error(`1 microbe must be reserved for ${cardName}`);
                    }
                }
            }
            this.runInputCb(pi.cb(foundCard, howToPay));
        }
        else if (pi instanceof SelectCard_1.SelectCard) {
            this.checkInputLength(input, 1);
            if (input[0].length < pi.config.min)
                throw new Error('Not enough cards selected');
            if (input[0].length > pi.config.max)
                throw new Error('Too many cards selected');
            const mappedCards = [];
            for (const cardName of input[0]) {
                const cardIndex = PlayerInput_1.PlayerInput.getCard(pi.cards, cardName);
                mappedCards.push(cardIndex.card);
                if (((_a = pi.config.enabled) === null || _a === void 0 ? void 0 : _a[cardIndex.idx]) === false) {
                    throw new Error('Selected unavailable card');
                }
            }
            this.runInputCb(pi.cb(mappedCards));
        }
        else if (pi instanceof SelectAmount_1.SelectAmount) {
            this.checkInputLength(input, 1, 1);
            const amount = parseInt(input[0][0]);
            if (isNaN(amount))
                throw new Error('Amount is not a number');
            this.runInputCb(pi.cb(amount));
        }
        else if (pi instanceof SelectSpace_1.SelectSpace) {
            this.checkInputLength(input, 1, 1);
            const foundSpace = pi.availableSpaces.find((space) => space.id === input[0][0]);
            if (foundSpace === undefined) {
                throw new Error('Space not available');
            }
            if (this.howToAffordReds !== undefined && this.howToAffordReds.spaces !== undefined) {
                this.howToAffordReds.spaces = this.howToAffordReds.spaces.get(foundSpace);
            }
            this.runInputCb(pi.cb(foundSpace));
        }
        else if (pi instanceof SelectPlayer_1.SelectPlayer) {
            this.checkInputLength(input, 1, 1);
            const foundPlayer = pi.players.find((player) => player.color === input[0][0] || player.id === input[0][0]);
            if (foundPlayer === undefined) {
                throw new Error('Player not available');
            }
            this.runInputCb(pi.cb(foundPlayer));
        }
        else if (pi instanceof SelectDelegate_1.SelectDelegate) {
            this.checkInputLength(input, 1, 1);
            const foundPlayer = pi.players.find((player) => player === input[0][0] ||
                (player instanceof Player && (player.id === input[0][0] || player.color === input[0][0])));
            if (foundPlayer === undefined) {
                throw new Error('Player not available');
            }
            this.runInputCb(pi.cb(foundPlayer));
        }
        else if (pi instanceof SelectHowToPay_1.SelectHowToPay) {
            this.checkInputLength(input, 1, 1);
            const howToPay = this.parseHowToPayJSON(input[0][0]);
            this.runInputCb(pi.cb(howToPay));
        }
        else if (pi instanceof SelectProductionToLose_1.SelectProductionToLose) {
            const units = JSON.parse(input[0][0]);
            pi.cb(units);
        }
        else if (pi instanceof ShiftAresGlobalParameters_1.ShiftAresGlobalParameters) {
            const response = JSON.parse(input[0][0]);
            pi.cb(response);
        }
        else if (pi instanceof SelectPartyToSendDelegate_1.SelectPartyToSendDelegate) {
            this.checkInputLength(input, 1, 1);
            const party = (input[0][0]);
            if (party === undefined) {
                throw new Error('No party selected');
            }
            this.runInputCb(pi.cb(party));
        }
        else {
            throw new Error('Unsupported waitingFor');
        }
    }
    getAvailableBlueActionCount() {
        let count = this.getPlayableActionCards().length;
        if (this.game.gameOptions.fastModeOption)
            count += this.remainingStallActionsCount;
        return count;
    }
    getPlayableActionCards() {
        const result = [];
        this.corporationCards.forEach((corp) => {
            if (!this.actionsThisGeneration.has(corp.name) &&
                corp.action !== undefined &&
                corp.canAct !== undefined &&
                corp.canAct(this)) {
                result.push(corp);
            }
        });
        const playedCards = this.playedCards.filter((card) => card.cardType === CardType_1.CardType.ACTIVE || card.cardType === CardType_1.CardType.PRELUDE);
        for (const playedCard of playedCards) {
            if (playedCard.action !== undefined &&
                playedCard.canAct !== undefined &&
                !this.actionsThisGeneration.has(playedCard.name) &&
                playedCard.canAct(this)) {
                result.push(playedCard);
            }
        }
        return result;
    }
    getPlayableLeaderCards() {
        const leaders = this.playedCards.filter((card) => card.cardType === CardType_1.CardType.LEADER);
        return leaders.filter((leader) => leader.canAct !== undefined && leader.canAct(this) && leader.isDisabled === false);
    }
    runProductionPhase() {
        this.actionsThisGeneration.clear();
        this.removingPlayers = [];
        this.turmoilPolicyActionUsed = false;
        this.politicalAgendasActionUsedCount = 0;
        this.dominantPartyActionUsedCount = 0;
        if (this.cardIsInEffect(CardName_1.CardName.SUPERCAPACITORS)) {
            Supercapacitors_1.Supercapacitors.onProduction(this);
        }
        else {
            this.heat += this.energy;
            this.energy = 0;
            this.finishProductionPhase();
        }
    }
    finishProductionPhase() {
        this.megaCredits += this.megaCreditProduction + this.terraformRating;
        this.steel += this.steelProduction;
        this.titanium += this.titaniumProduction;
        this.energy += this.energyProduction;
        this.plants += this.plantProduction;
        this.heat += this.heatProduction;
        this.corporationCards.forEach((corp) => {
            if (corp.onProductionPhase !== undefined) {
                corp.onProductionPhase(this);
            }
        });
        if (this.cardIsInEffect(CardName_1.CardName.PRESERVATION_PROGRAM)) {
            this.preservationProgramActive = true;
        }
        this.playedCards
            .filter((card) => card.cardType === CardType_1.CardType.LEADER && card.name !== CardName_1.CardName.DARWIN)
            .forEach((card) => card.opgActionIsActive = false);
    }
    returnTradeFleets() {
        if (this.game.syndicatePirateRaider === undefined) {
            this.tradesThisGeneration = 0;
            this.hasTradedThisTurn = false;
        }
        else if (this.game.syndicatePirateRaider === this.id) {
            if (this.cardIsInEffect(CardName_1.CardName.HUAN)) {
                this.game.getPlayers().forEach((player) => {
                    player.tradesThisGeneration = 50;
                });
            }
            this.tradesThisGeneration = 0;
            this.hasTradedThisTurn = false;
        }
    }
    doneWorldGovernmentTerraforming() {
        this.game.deferredActions.runAll(() => this.game.doneWorldGovernmentTerraforming());
    }
    worldGovernmentTerraforming() {
        const game = this.game;
        if (this.hasConceded) {
            this.doneWorldGovernmentTerraforming();
            game.log('WGT phase was skipped for ${0}', (b) => b.player(this));
            return undefined;
        }
        const action = new OrOptions_1.OrOptions();
        action.title = 'Select action for World Government Terraforming';
        action.buttonLabel = 'Confirm';
        if (game.gameOptions.silverCubeVariant === true) {
            SilverCubeHandler_1.SilverCubeHandler.addSilverCubeWGTOptions(this, game, action);
        }
        else {
            if (game.getTemperature() < constants.MAX_TEMPERATURE) {
                action.options.push(new SelectOption_1.SelectOption('Increase temperature', 'Increase', () => {
                    game.increaseTemperature(this, 1);
                    game.log('${0} acted as World Government and increased temperature', (b) => b.player(this));
                    return undefined;
                }));
            }
            if (game.getOxygenLevel() < constants.MAX_OXYGEN_LEVEL) {
                action.options.push(new SelectOption_1.SelectOption('Increase oxygen', 'Increase', () => {
                    game.increaseOxygenLevel(this, 1);
                    game.log('${0} acted as World Government and increased oxygen level', (b) => b.player(this));
                    return undefined;
                }));
            }
            if (game.canAddOcean()) {
                action.options.push(new SelectSpace_1.SelectSpace('Add an ocean', game.board.getAvailableSpacesForOcean(this), TileType_1.TileType.OCEAN, (space) => {
                    game.addOceanTile(this, space.id, SpaceType_1.SpaceType.OCEAN);
                    game.log('${0} acted as World Government and placed an ocean', (b) => b.player(this));
                    return undefined;
                }));
            }
            if (game.getVenusScaleLevel() < constants.MAX_VENUS_SCALE && game.gameOptions.venusNextExtension) {
                action.options.push(new SelectOption_1.SelectOption('Increase Venus scale', 'Increase', () => {
                    game.increaseVenusScaleLevel(this, 1);
                    game.log('${0} acted as World Government and increased Venus scale', (b) => b.player(this));
                    return undefined;
                }));
            }
        }
        if (game.gameOptions.aresExtension && game.gameOptions.aresExtremeVariant && game.isSoloMode()) {
            const unprotectedHazardSpaces = Eris_1.Eris.getAllUnprotectedHazardSpaces(game);
            if (unprotectedHazardSpaces.length > 0) {
                action.options.push(new SelectSpace_1.SelectSpace('Remove an unprotected hazard', Eris_1.Eris.getAllUnprotectedHazardSpaces(game), undefined, (space) => {
                    space.tile = undefined;
                    game.log('${0} acted as World Government and removed a hazard tile', (b) => b.player(this));
                    return undefined;
                }));
            }
        }
        MoonExpansion_1.MoonExpansion.ifMoon(game, (moonData) => {
            if (moonData.colonyRate < constants.MAXIMUM_COLONY_RATE) {
                action.options.push(new SelectOption_1.SelectOption('Increase the Moon colony rate', 'Increase', () => {
                    MoonExpansion_1.MoonExpansion.raiseColonyRate(this, 1);
                    return undefined;
                }));
            }
            if (moonData.miningRate < constants.MAXIMUM_MINING_RATE) {
                action.options.push(new SelectOption_1.SelectOption('Increase the Moon mining rate', 'Increase', () => {
                    MoonExpansion_1.MoonExpansion.raiseMiningRate(this, 1);
                    return undefined;
                }));
            }
            if (moonData.logisticRate < constants.MAXIMUM_LOGISTICS_RATE) {
                action.options.push(new SelectOption_1.SelectOption('Increase the Moon logistics rate', 'Increase', () => {
                    MoonExpansion_1.MoonExpansion.raiseLogisticRate(this, 1);
                    return undefined;
                }));
            }
        });
        this.setWaitingFor(action, () => {
            this.doneWorldGovernmentTerraforming();
        });
    }
    dealCards(quantity, cards) {
        for (let i = 0; i < quantity; i++) {
            cards.push(this.game.dealer.dealCard(this.game, true));
        }
    }
    runDraftPhase(initialDraft, playerName, passedCards) {
        let cardsToKeep = 1;
        let cards = [];
        if (passedCards === undefined) {
            if (!initialDraft) {
                let cardsToDraw = 4;
                if (LunaProjectOffice_1.LunaProjectOffice.isActive(this)) {
                    cardsToDraw = 5;
                    cardsToKeep = 2;
                }
                this.dealCards(cardsToDraw, cards);
            }
            else {
                this.dealCards(5, cards);
            }
        }
        else {
            cards = passedCards;
        }
        const message = cardsToKeep === 1 ?
            'Select a card to keep and pass the rest to ${0}' :
            'Select two cards to keep and pass the rest to ${0}';
        const selectCard = new SelectCard_1.SelectCard({
            message: message,
            data: [{ type: LogMessageDataType_1.LogMessageDataType.RAW_STRING, value: playerName }],
        }, 'Keep', cards, (foundCards) => {
            foundCards.forEach((card) => {
                this.draftedCards.push(card);
                cards = cards.filter((c) => c !== card);
            });
            LogHelper_1.LogHelper.logDraftedCards(this, foundCards, cards, playerName);
            this.game.playerIsFinishedWithDraftingPhase(initialDraft, this, cards);
            return undefined;
        }, { min: cardsToKeep, max: cardsToKeep, played: false });
        if (this.hasConceded) {
            selectCard.cb([selectCard.cards[0]]);
            return;
        }
        this.setWaitingFor(selectCard);
    }
    spendableMegacredits() {
        const spendableMegacredits = this.megaCredits;
        return spendableMegacredits + (this.canUseHeatAsMegaCredits ? this.availableHeat : 0);
    }
    runResearchPhase(draftVariant) {
        let dealtCards = [];
        if (!draftVariant) {
            this.dealCards(LunaProjectOffice_1.LunaProjectOffice.isActive(this) ? 5 : 4, dealtCards);
        }
        else {
            dealtCards = this.draftedCards;
            this.draftedCards = [];
        }
        const action = DrawCards_1.DrawCards.choose(this, dealtCards, { paying: true });
        if (this.hasConceded) {
            action.cb([]);
            return;
        }
        this.setWaitingFor(action, () => this.game.playerIsFinishedWithResearchPhase(this));
    }
    getCardCost(card) {
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.POPULISTS, TurmoilPolicy_1.TurmoilPolicy.POPULISTS_DEFAULT_POLICY)) {
            return card.cost;
        }
        let cost = card.cost;
        cost -= this.cardDiscount;
        this.playedCards.forEach((playedCard) => {
            if (playedCard.getCardDiscount !== undefined) {
                cost -= playedCard.getCardDiscount(this, card);
            }
        });
        this.corporationCards.forEach((corp) => {
            if (corp.getCardDiscount !== undefined) {
                cost -= corp.getCardDiscount(this, card);
            }
        });
        this.removedFromPlayCards.forEach((removedFromPlayCard) => {
            if (removedFromPlayCard.getCardDiscount !== undefined) {
                cost -= removedFromPlayCard.getCardDiscount(this, card);
            }
        });
        if (card.tags.includes(Tags_1.Tags.SPACE) && PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.UNITY, TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_4)) {
            cost -= 2;
        }
        if (card.tags.includes(Tags_1.Tags.ENERGY) && PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.EMPOWER, TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_4)) {
            cost -= 3;
        }
        if (card.tags.includes(Tags_1.Tags.EARTH) && PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.BUREAUCRATS, TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_POLICY_4)) {
            const earthTagCount = card.tags.filter((tag) => tag === Tags_1.Tags.EARTH).length;
            cost -= earthTagCount * 3;
        }
        if (card.cardType === CardType_1.CardType.EVENT && PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.CENTRISTS, TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_4)) {
            cost -= 2;
        }
        cost = MarsCoalition_1.MarsCoalition.applyDominantPartyCardDiscounts(this, card, cost);
        return Math.max(cost, 0);
    }
    canUseSteel(card) {
        return card.tags.includes(Tags_1.Tags.BUILDING);
    }
    canUseTitanium(card) {
        return card.tags.includes(Tags_1.Tags.SPACE);
    }
    canUseGraphene(card) {
        if (this.cardIsInEffect(CardName_1.CardName.CARBON_NANOSYSTEMS) === false)
            return false;
        return card.tags.includes(Tags_1.Tags.SPACE) || card.tags.includes(Tags_1.Tags.CITY);
    }
    canUseMicrobes(card) {
        return card.tags.includes(Tags_1.Tags.PLANT);
    }
    canUseFloaters(card) {
        return card.tags.includes(Tags_1.Tags.VENUS);
    }
    canUseAsteroids(card) {
        if (!this.isCorporation(CardName_1.CardName.KUIPER_COOPERATIVE))
            return false;
        const kuiperCooperative = this.corporationCards.find((corp) => corp.name === CardName_1.CardName.KUIPER_COOPERATIVE);
        if (kuiperCooperative.resourceCount === 0)
            return false;
        return card.name === CardName_1.CardName.ASTEROID_STANDARD_PROJECT || card.name === CardName_1.CardName.AQUIFER_STANDARD_PROJECT;
    }
    canUseSpireScience(card) {
        if (!this.isCorporation(CardName_1.CardName.SPIRE))
            return false;
        const spire = this.corporationCards.find((corp) => corp.name === CardName_1.CardName.SPIRE);
        if (spire.resourceCount === 0)
            return false;
        const standardProjectNames = this.getStandardProjects().map((c) => c.name);
        return standardProjectNames.includes(card.name);
    }
    canUsePlants(card) {
        if (this.cardIsInEffect(CardName_1.CardName.MARTIAN_LUMBER_CORP) === false)
            return false;
        return card.tags.includes(Tags_1.Tags.BUILDING);
    }
    getMcTradeCost() {
        let cost = constants_1.MC_TRADE_COST - this.colonyTradeDiscount;
        if (this.hasBureaucratsColonyTradePenalty)
            cost += 1;
        return cost;
    }
    getEnergyTradeCost() {
        let cost = constants_1.ENERGY_TRADE_COST - this.colonyTradeDiscount;
        if (this.hasBureaucratsColonyTradePenalty)
            cost += 1;
        return cost;
    }
    getTitaniumTradeCost() {
        let cost = constants_1.TITANIUM_TRADE_COST - this.colonyTradeDiscount;
        if (this.hasBureaucratsColonyTradePenalty)
            cost += 1;
        return cost;
    }
    playPreludeCard() {
        return new SelectCard_1.SelectCard('Select prelude card to play', 'Play', this.preludeCardsInHand, (foundCards) => {
            if (foundCards[0].canPlay === undefined || foundCards[0].canPlay(this)) {
                return this.playCard(foundCards[0]);
            }
            else {
                this.preludeCardsInHand.splice(this.preludeCardsInHand.indexOf(foundCards[0]), 1);
                this.game.log('${0} was discarded for 15 M€ as ${1} could not afford to play it', (b) => b.card(foundCards[0]).player(this));
                this.addResource(Resources_1.Resources.MEGACREDITS, 15, { log: true });
                foundCards[0].warning = undefined;
                return undefined;
            }
        });
    }
    payMegacreditsDeferred(cost, title, afterPay) {
        this.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(this, cost, { title, afterPay }));
    }
    checkHowToPayAndPlayCard(selectedCard, howToPay) {
        const cardCost = this.getCardCost(selectedCard);
        let totalToPay = 0;
        const canUseSteel = this.canUseSteel(selectedCard);
        const canUseTitanium = this.canUseTitanium(selectedCard);
        const canUseGraphene = this.canUseGraphene(selectedCard);
        const canUseAsteroids = this.canUseAsteroids(selectedCard);
        const canUseSpireScience = this.canUseSpireScience(selectedCard);
        const canUsePlants = this.canUsePlants(selectedCard);
        if (canUsePlants && howToPay.plants > 0) {
            if (howToPay.plants > this.plants) {
                throw new Error('Do not have enough plants');
            }
            totalToPay += howToPay.plants * constants_1.DEFAULT_PLANT_VALUE;
        }
        if (canUseSteel && howToPay.steel > 0) {
            if (howToPay.steel > this.steel) {
                throw new Error('Do not have enough steel');
            }
            totalToPay += howToPay.steel * this.getSteelValue();
        }
        if (canUseTitanium && howToPay.titanium > 0) {
            if (howToPay.titanium > this.titanium) {
                throw new Error('Do not have enough titanium');
            }
            totalToPay += howToPay.titanium * this.getTitaniumValue();
        }
        if (canUseGraphene && howToPay.graphene > 0) {
            totalToPay += howToPay.graphene * constants_1.DEFAULT_GRAPHENE_VALUE;
        }
        if (canUseAsteroids && howToPay.asteroids > 0) {
            totalToPay += howToPay.asteroids;
        }
        if (canUseSpireScience && howToPay.spireScience > 0) {
            totalToPay += howToPay.spireScience;
        }
        if (this.canUseHeatAsMegaCredits && howToPay.heat !== undefined) {
            totalToPay += howToPay.heat;
        }
        if (howToPay.microbes !== undefined) {
            totalToPay += howToPay.microbes * constants_1.DEFAULT_MICROBES_VALUE;
        }
        if (howToPay.floaters !== undefined && howToPay.floaters > 0) {
            if (selectedCard.name === CardName_1.CardName.STRATOSPHERIC_BIRDS && howToPay.floaters === this.getFloatersCanSpend()) {
                const cardsWithFloater = this.getCardsWithResources(ResourceType_1.ResourceType.FLOATER);
                if (cardsWithFloater.length === 1) {
                    throw new Error('Cannot spend all floaters to play Stratospheric Birds');
                }
            }
            totalToPay += howToPay.floaters * constants_1.DEFAULT_FLOATERS_VALUE;
        }
        if (howToPay.science !== undefined)
            totalToPay += howToPay.science;
        if (howToPay.megaCredits > this.megaCredits)
            throw new Error('Do not have enough M€');
        totalToPay += howToPay.megaCredits;
        if (totalToPay < cardCost)
            throw new Error('Did not spend enough to pay for card');
        this.totalSpend += cardCost;
        return this.playCard(selectedCard, howToPay);
    }
    playProjectCard() {
        return new SelectHowToPayForProjectCard_1.SelectHowToPayForProjectCard(this, this.getPlayableCards(), (selectedCard, howToPay) => this.checkHowToPayAndPlayCard(selectedCard, howToPay));
    }
    getMicrobesCanSpend() {
        const psychrophiles = this.playedCards.find((card) => card.name === CardName_1.CardName.PSYCHROPHILES);
        if (psychrophiles !== undefined)
            return this.getResourcesOnCard(psychrophiles);
        return 0;
    }
    getFloatersCanSpend() {
        const dirigibles = this.playedCards.find((card) => card.name === CardName_1.CardName.DIRIGIBLES);
        if (dirigibles !== undefined)
            return this.getResourcesOnCard(dirigibles);
        return 0;
    }
    getSpendableScienceResources() {
        const lunaArchives = this.playedCards.find((card) => card.name === CardName_1.CardName.LUNA_ARCHIVES);
        if (lunaArchives !== undefined)
            return this.getResourcesOnCard(lunaArchives);
        return 0;
    }
    getSpendableGrapheneResources() {
        const carbonNanosystems = this.playedCards.find((card) => card.name === CardName_1.CardName.CARBON_NANOSYSTEMS);
        if (carbonNanosystems !== undefined)
            return this.getResourcesOnCard(carbonNanosystems);
        return 0;
    }
    getSpendableAsteroidResources() {
        const kuiperCooperative = this.corporationCards.find((card) => card.name === CardName_1.CardName.KUIPER_COOPERATIVE);
        if (kuiperCooperative !== undefined) {
            return this.getResourcesOnCard(kuiperCooperative);
        }
        return 0;
    }
    getSpendableSpireScienceResources() {
        const spire = this.corporationCards.find((card) => card.name === CardName_1.CardName.SPIRE);
        if (spire !== undefined)
            return this.getResourcesOnCard(spire);
        return 0;
    }
    playCard(selectedCard, howToPay, addToPlayedCards = true) {
        if (howToPay !== undefined) {
            this.steel -= howToPay.steel;
            this.titanium -= howToPay.titanium;
            this.megaCredits -= howToPay.megaCredits;
            this.plants -= howToPay.plants;
            if (howToPay.heat > 0) {
                this.game.defer(new DeferredAction_1.DeferredAction(this, () => this.spendHeat(howToPay.heat)));
            }
            for (const playedCard of this.playedCards) {
                if (playedCard.name === CardName_1.CardName.PSYCHROPHILES) {
                    this.removeResourceFrom(playedCard, howToPay.microbes);
                }
                if (playedCard.name === CardName_1.CardName.DIRIGIBLES) {
                    this.removeResourceFrom(playedCard, howToPay.floaters);
                }
                if (playedCard.name === CardName_1.CardName.LUNA_ARCHIVES) {
                    this.removeResourceFrom(playedCard, howToPay.science);
                }
                if (playedCard.name === CardName_1.CardName.CARBON_NANOSYSTEMS) {
                    this.removeResourceFrom(playedCard, howToPay.graphene);
                }
            }
            for (const corp of this.corporationCards) {
                if (corp.name === CardName_1.CardName.KUIPER_COOPERATIVE) {
                    this.removeResourceFrom(corp, howToPay.asteroids);
                }
                if (corp.name === CardName_1.CardName.SPIRE) {
                    this.removeResourceFrom(corp, howToPay.spireScience);
                }
            }
        }
        if (selectedCard.howToAffordReds !== undefined) {
            this.howToAffordReds = selectedCard.howToAffordReds;
        }
        if (this.game.gameOptions.coloniesExtension && selectedCard.resourceType !== undefined) {
            this.game.colonies.forEach((colony) => {
                if (colony.resourceType !== undefined && colony.resourceType === selectedCard.resourceType) {
                    colony.isActive = true;
                }
            });
            this.game.activateVenusColony(selectedCard);
        }
        if (selectedCard.cardType !== CardType_1.CardType.PROXY) {
            this.lastCardPlayed = selectedCard;
            this.game.log('${0} played ${1}', (b) => b.player(this).card(selectedCard));
        }
        if (addToPlayedCards && selectedCard.name === CardName_1.CardName.VALUABLE_GASES) {
            this.game.defer(new DeferredAction_1.DeferredAction(this, () => {
                this.playedCards.push(selectedCard);
                return undefined;
            }), DeferredAction_1.Priority.SUPERPOWER);
        }
        const action = selectedCard.play(this);
        this.defer(action, DeferredAction_1.Priority.DEFAULT);
        const projectCardIndex = this.cardsInHand.findIndex((card) => card.name === selectedCard.name);
        const preludeCardIndex = this.preludeCardsInHand.findIndex((card) => card.name === selectedCard.name);
        const leaderCardIndex = this.leaderCardsInHand.findIndex((card) => card.name === selectedCard.name);
        if (projectCardIndex !== -1) {
            this.cardsInHand.splice(projectCardIndex, 1);
        }
        else if (preludeCardIndex !== -1) {
            this.preludeCardsInHand.splice(preludeCardIndex, 1);
        }
        else if (leaderCardIndex !== -1) {
            this.leaderCardsInHand.splice(leaderCardIndex, 1);
        }
        const card = this.playedCards.find((card) => card.name === CardName_1.CardName.SELF_REPLICATING_ROBOTS);
        if (card instanceof SelfReplicatingRobots_1.SelfReplicatingRobots) {
            for (const targetCard of card.targetCards) {
                if (targetCard.card.name === selectedCard.name) {
                    const index = card.targetCards.indexOf(targetCard);
                    card.targetCards.splice(index, 1);
                }
            }
        }
        if (addToPlayedCards && [CardName_1.CardName.LAW_SUIT, CardName_1.CardName.VALUABLE_GASES].includes(selectedCard.name) === false) {
            this.playedCards.push(selectedCard);
        }
        const lastRemovedFromPlayCard = this.removedFromPlayCards[this.removedFromPlayCards.length - 1];
        if (lastRemovedFromPlayCard !== undefined && lastRemovedFromPlayCard.name === CardName_1.CardName.SPECIAL_DESIGN) {
            this.removedFromPlayCards.pop();
        }
        TurmoilHandler_1.TurmoilHandler.applyOnCardPlayedEffect(this, selectedCard);
        for (const somePlayer of this.game.getPlayers()) {
            somePlayer.corporationCards.forEach((corp) => {
                if (corp.onCardPlayed !== undefined) {
                    const actionFromPlayedCard = corp.onCardPlayed(this, selectedCard);
                    if (actionFromPlayedCard !== undefined) {
                        this.game.defer(new DeferredAction_1.DeferredAction(this, () => actionFromPlayedCard));
                    }
                }
            });
            for (const playedCard of somePlayer.playedCards) {
                if (playedCard.onCardPlayed !== undefined) {
                    const actionFromPlayedCard = playedCard.onCardPlayed(this, selectedCard);
                    if (actionFromPlayedCard !== undefined) {
                        this.game.defer(new DeferredAction_1.DeferredAction(this, () => actionFromPlayedCard));
                    }
                }
            }
        }
        return undefined;
    }
    playActionCard() {
        return new SelectCard_1.SelectCard('Perform an action from a played card', 'Take action', this.getPlayableActionCards(), (foundCards) => {
            const foundCard = foundCards[0];
            this.game.log('${0} used ${1} action', (b) => b.player(this).card(foundCard));
            const action = foundCard.action(this);
            if (action !== undefined) {
                this.game.defer(new DeferredAction_1.DeferredAction(this, () => action));
            }
            this.actionsThisGeneration.add(foundCard.name);
            return undefined;
        }, { selectBlueCardAction: true });
    }
    useLeaderAction() {
        return new SelectCard_1.SelectCard('Use CEO once per game action', 'Take action', this.getPlayableLeaderCards(), (foundCards) => {
            const foundCard = foundCards[0];
            this.game.log('${0} used ${1} action', (b) => b.player(this).card(foundCard));
            const action = foundCard.action(this);
            if (action !== undefined) {
                this.game.defer(new DeferredAction_1.DeferredAction(this, () => action));
            }
            this.actionsThisGeneration.add(foundCard.name);
            return undefined;
        });
    }
    drawCard(count, options) {
        return DrawCards_1.DrawCards.keepAll(this, count, options).execute();
    }
    drawCardKeepSome(count, options) {
        return DrawCards_1.DrawCards.keepSome(this, count, options).execute();
    }
    get availableHeat() {
        if (!this.isCorporation(CardName_1.CardName.STORMCRAFT_INCORPORATED))
            return this.heat;
        const stormcraft = this.corporationCards.find((card) => card.name === CardName_1.CardName.STORMCRAFT_INCORPORATED);
        return this.heat + (stormcraft.resourceCount * 2);
    }
    spendHeat(amount, cb = () => undefined) {
        if (this.corporationCards.some((corp) => corp.name === CardName_1.CardName.STORMCRAFT_INCORPORATED)) {
            const stormcraft = this.corporationCards.find((corp) => corp.name === CardName_1.CardName.STORMCRAFT_INCORPORATED);
            if (stormcraft !== undefined && stormcraft.resourceCount !== undefined && amount > 0) {
                return stormcraft.spendHeat(this, amount, cb);
            }
        }
        this.deductResource(Resources_1.Resources.HEAT, amount);
        return cb();
    }
    spendGraphene(amount) {
        if (this.cardIsInEffect(CardName_1.CardName.CARBON_NANOSYSTEMS)) {
            const carbonNanosystems = this.playedCards.find((card) => card.name === CardName_1.CardName.CARBON_NANOSYSTEMS);
            this.removeResourceFrom(carbonNanosystems, amount);
        }
        return undefined;
    }
    spendAsteroids(amount) {
        if (this.isCorporation(CardName_1.CardName.KUIPER_COOPERATIVE)) {
            const kuiperCooperative = this.corporationCards.find((card) => card.name === CardName_1.CardName.KUIPER_COOPERATIVE);
            this.removeResourceFrom(kuiperCooperative, amount);
        }
        return undefined;
    }
    spendSpireScience(amount) {
        if (this.isCorporation(CardName_1.CardName.SPIRE)) {
            const spire = this.corporationCards.find((card) => card.name === CardName_1.CardName.SPIRE);
            this.removeResourceFrom(spire, amount);
        }
        return undefined;
    }
    tradeWithColony(openColonies) {
        const opts = [];
        let payWith = undefined;
        const coloniesModel = this.game.getColoniesModel(openColonies);
        const titanFloatingLaunchPad = this.playedCards.find((card) => card.name === CardName_1.CardName.TITAN_FLOATING_LAUNCHPAD);
        const darksideSmugglersUnion = this.playedCards.find((card) => card.name === CardName_1.CardName.DARKSIDE_SMUGGLERS_UNION);
        const mcTradeAmount = this.getMcTradeCost();
        const energyTradeAmount = this.getEnergyTradeCost();
        const titaniumTradeAmount = this.getTitaniumTradeCost();
        const selectColony = new SelectColony_1.SelectColony('Select colony tile for trade', 'trade', coloniesModel, (colonyName) => {
            openColonies.forEach((colony) => {
                if (colony.name === colonyName) {
                    if (payWith === Resources_1.Resources.MEGACREDITS) {
                        this.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(this, mcTradeAmount, {
                            title: 'Select how to pay ' + mcTradeAmount + ' for colony trade',
                            afterPay: () => {
                                this.game.log('${0} spent ${1} M€ to trade with ${2}', (b) => b.player(this).number(mcTradeAmount).colony(colony));
                                colony.trade(this);
                            },
                        }));
                    }
                    else if (payWith === Resources_1.Resources.ENERGY) {
                        this.energy -= energyTradeAmount;
                        this.game.log('${0} spent ${1} energy to trade with ${2}', (b) => b.player(this).number(energyTradeAmount).colony(colony));
                        colony.trade(this);
                    }
                    else if (payWith === Resources_1.Resources.TITANIUM) {
                        this.titanium -= titaniumTradeAmount;
                        this.game.log('${0} spent ${1} titanium to trade with ${2}', (b) => b.player(this).number(titaniumTradeAmount).colony(colony));
                        colony.trade(this);
                    }
                    else if (payWith === ResourceType_1.ResourceType.FLOATER && titanFloatingLaunchPad !== undefined && titanFloatingLaunchPad.resourceCount) {
                        titanFloatingLaunchPad.resourceCount--;
                        this.actionsThisGeneration.add(titanFloatingLaunchPad.name);
                        this.game.log('${0} spent 1 floater to trade with ${1}', (b) => b.player(this).colony(colony));
                        colony.trade(this);
                    }
                    else if (payWith === undefined && darksideSmugglersUnion !== undefined && darksideSmugglersUnion.canAct(this)) {
                        this.actionsThisGeneration.add(darksideSmugglersUnion.name);
                        this.game.log('${0} traded with ${1} using ${2} action', (b) => b.player(this).colony(colony).card(darksideSmugglersUnion));
                        colony.trade(this);
                    }
                    return undefined;
                }
                return undefined;
            });
            return undefined;
        });
        const howToPayForTrade = new OrOptions_1.OrOptions();
        howToPayForTrade.title = 'Pay trade fee';
        howToPayForTrade.buttonLabel = 'Pay';
        const payWithMC = new SelectOption_1.SelectOption('Pay ' + mcTradeAmount + ' M€', '', () => {
            payWith = Resources_1.Resources.MEGACREDITS;
            return undefined;
        });
        const payWithEnergy = new SelectOption_1.SelectOption('Pay ' + energyTradeAmount + ' Energy', '', () => {
            payWith = Resources_1.Resources.ENERGY;
            return undefined;
        });
        const payWithTitanium = new SelectOption_1.SelectOption('Pay ' + titaniumTradeAmount + ' Titanium', '', () => {
            payWith = Resources_1.Resources.TITANIUM;
            return undefined;
        });
        if (darksideSmugglersUnion !== undefined &&
            darksideSmugglersUnion.canAct(this) &&
            !this.actionsThisGeneration.has(darksideSmugglersUnion.name)) {
            howToPayForTrade.options.push(new SelectOption_1.SelectOption('Use Darkside Smugglers\' Union action', '', () => {
                payWith = undefined;
                return undefined;
            }));
        }
        if (titanFloatingLaunchPad !== undefined &&
            titanFloatingLaunchPad.resourceCount !== undefined &&
            titanFloatingLaunchPad.resourceCount > 0 &&
            !this.actionsThisGeneration.has(titanFloatingLaunchPad.name)) {
            howToPayForTrade.options.push(new SelectOption_1.SelectOption('Pay 1 Floater (use Titan Floating Launch-pad action)', '', () => {
                payWith = ResourceType_1.ResourceType.FLOATER;
                return undefined;
            }));
        }
        if (this.energy >= energyTradeAmount)
            howToPayForTrade.options.push(payWithEnergy);
        if (this.titanium >= titaniumTradeAmount)
            howToPayForTrade.options.push(payWithTitanium);
        if (this.canAfford(mcTradeAmount))
            howToPayForTrade.options.push(payWithMC);
        opts.push(howToPayForTrade);
        opts.push(selectColony);
        const trade = new AndOptions_1.AndOptions(() => {
            return undefined;
        }, ...opts);
        trade.title = 'Trade with a colony tile';
        trade.buttonLabel = 'Trade';
        return trade;
    }
    getMilestoneCost() {
        if (this.cardIsInEffect(CardName_1.CardName.VAN_ALLEN))
            return 0;
        if (this.isCorporation(CardName_1.CardName.NIRGAL_ENTERPRISES))
            return 0;
        if (this.game.gameOptions.automaSoloVariant)
            return 0;
        return constants_1.MILESTONE_COST;
    }
    claimMilestone(milestone) {
        return new SelectOption_1.SelectOption(milestone.name, 'Claim - ' + '(' + milestone.name + ')', () => {
            this.game.claimedMilestones.push({ player: this, milestone: milestone });
            const cost = this.getMilestoneCost();
            this.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(this, cost, { title: 'Select how to pay for milestone' }));
            if (milestone.name === 'Monument')
                Monument_1.Monument.discardCards(this);
            if (milestone.name === 'Briber')
                Briber_1.Briber.payBribe(this);
            VanAllen_1.VanAllen.onMilestoneClaimed(this.game);
            this.game.log('${0} claimed ${1} milestone', (b) => b.player(this).milestone(milestone));
            return undefined;
        });
    }
    fundAward(award) {
        return new SelectOption_1.SelectOption(award.name, 'Fund - ' + '(' + award.name + ')', () => {
            this.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(this, this.game.getAwardFundingCost(this), { title: 'Select how to pay for award' }));
            this.game.fundAward(this, award);
            return undefined;
        });
    }
    endTurnOption() {
        return new SelectOption_1.SelectOption('End Turn', 'End', () => {
            this.actionsTakenThisRound = 1;
            this.game.log('${0} ended turn', (b) => b.player(this));
            return undefined;
        });
    }
    stallOption() {
        return new SelectOption_1.SelectOption('End Turn (' + this.remainingStallActionsCount + '/2 remaining)', 'End', () => {
            this.actionsTakenThisRound = 1;
            this.remainingStallActionsCount -= 1;
            this.game.log('${0} ended turn', (b) => b.player(this));
            return undefined;
        });
    }
    pass() {
        this.game.playerHasPassed(this);
        this.lastCardPlayed = undefined;
        if (this.isCorporation(CardName_1.CardName.BENTENMARU)) {
            this.megaCredits = 0;
        }
    }
    passOption() {
        return new SelectOption_1.SelectOption('Pass for this generation', 'Pass', () => {
            this.pass();
            this.game.log('${0} passed', (b) => b.player(this));
            return undefined;
        });
    }
    concedeOption() {
        return new SelectOption_1.SelectOption('Concede this game', 'Concede', () => {
            const orOptions = new OrOptions_1.OrOptions();
            orOptions.title = 'Are you sure you want to concede?';
            orOptions.options.push(new SelectOption_1.SelectOption('Concede this game', 'Concede', () => {
                this.hasConceded = true;
                this.pass();
                this.game.log('${0} conceded the game', (b) => b.player(this));
                return undefined;
            }));
            orOptions.options.push(new SelectOption_1.SelectOption('Continue playing', 'Confirm', () => {
                this.actionsTakenThisRound--;
                this.actionsTakenThisGame--;
                return undefined;
            }));
            return orOptions;
        });
    }
    takeActionForFinalGreenery() {
        if (this.game.deferredActions.length > 0) {
            this.resolveFinalGreeneryDeferredActions();
            return;
        }
        if (this.game.canPlaceGreenery(this)) {
            const action = new OrOptions_1.OrOptions();
            action.title = 'Place any final greenery from plants';
            action.buttonLabel = 'Confirm';
            action.options.push(new SelectSpace_1.SelectSpace('Select space for greenery', this.game.board.getAvailableSpacesForGreenery(this), TileType_1.TileType.GREENERY, (space) => {
                const shouldRaiseOxygen = this.game.isSoloMode() ? this.game.isSoloModeWin() : false;
                this.game.addGreenery(this, space.id, SpaceType_1.SpaceType.LAND, shouldRaiseOxygen);
                this.deductResource(Resources_1.Resources.PLANTS, this.plantsNeededForGreenery);
                this.takeActionForFinalGreenery();
                if (this.game.deferredActions.length > 0)
                    this.resolveFinalGreeneryDeferredActions();
                return undefined;
            }));
            action.options.push(new SelectOption_1.SelectOption('Don\'t place a greenery', 'Confirm', () => {
                this.game.playerIsDoneWithGame(this);
                return undefined;
            }));
            this.setWaitingForSafely(action);
            return;
        }
        if (this.game.deferredActions.length > 0) {
            this.resolveFinalGreeneryDeferredActions();
        }
        else {
            this.game.playerIsDoneWithGame(this);
        }
    }
    resolveFinalGreeneryDeferredActions() {
        this.game.deferredActions.runAll(() => this.takeActionForFinalGreenery());
    }
    getPlayableCards() {
        const candidateCards = [...this.cardsInHand];
        const card = this.playedCards.find((card) => card.name === CardName_1.CardName.SELF_REPLICATING_ROBOTS);
        if (card instanceof SelfReplicatingRobots_1.SelfReplicatingRobots) {
            for (const targetCard of card.targetCards) {
                candidateCards.push(targetCard.card);
            }
        }
        return candidateCards.filter((card) => this.canPlay(card));
    }
    canPlay(card) {
        const baseCost = this.getCardCost(card) - MoonExpansion_1.MoonExpansion.spendableLunaArchiveResources(this, card);
        let redsCost = this.computeTerraformRatingBump(card) * constants_1.REDS_RULING_POLICY_COST;
        if (card.getActionDetails !== undefined) {
            const actionDetails = card.getActionDetails(this, card);
            if (RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(this, this.game, actionDetails).canAfford) {
                redsCost = 0;
            }
        }
        if (card.reserveUnits !== undefined || card.reserveUnits === Units_1.Units.EMPTY) {
            card.reserveUnits = Units_1.Units.of({
                megacredits: redsCost,
                steel: card.reserveUnits.steel,
                titanium: card.reserveUnits.titanium,
                heat: card.reserveUnits.heat,
                plants: card.reserveUnits.plants,
                energy: card.reserveUnits.energy,
            });
        }
        else {
            card.reserveUnits = Units_1.Units.of({ megacredits: redsCost });
        }
        const canAfford = this.canAfford(baseCost, {
            steel: this.canUseSteel(card),
            titanium: this.canUseTitanium(card),
            floaters: this.canUseFloaters(card),
            microbes: this.canUseMicrobes(card),
            graphene: this.canUseGraphene(card),
            asteroids: this.canUseAsteroids(card),
            plants: this.canUsePlants(card),
            spireScience: this.canUseSpireScience(card),
            reserveUnits: MoonExpansion_1.MoonExpansion.adjustedReserveCosts(this, card),
        });
        return canAfford && (card.canPlay === undefined || card.canPlay(this));
    }
    canAfford(cost, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const reserveUnits = (_a = options === null || options === void 0 ? void 0 : options.reserveUnits) !== null && _a !== void 0 ? _a : Units_1.Units.EMPTY;
        if (reserveUnits.heat > 0) {
            const unitsWithoutHeat = Object.assign(Object.assign({}, reserveUnits), { heat: 0 });
            if (!this.hasUnits(unitsWithoutHeat)) {
                return false;
            }
            if (this.availableHeat < reserveUnits.heat) {
                return false;
            }
        }
        else {
            if (!this.hasUnits(reserveUnits)) {
                return false;
            }
        }
        const canUseSteel = (_b = options === null || options === void 0 ? void 0 : options.steel) !== null && _b !== void 0 ? _b : false;
        const canUseTitanium = (_c = options === null || options === void 0 ? void 0 : options.titanium) !== null && _c !== void 0 ? _c : false;
        const canUseFloaters = (_d = options === null || options === void 0 ? void 0 : options.floaters) !== null && _d !== void 0 ? _d : false;
        const canUseMicrobes = (_e = options === null || options === void 0 ? void 0 : options.microbes) !== null && _e !== void 0 ? _e : false;
        const canUseGraphene = (_f = options === null || options === void 0 ? void 0 : options.graphene) !== null && _f !== void 0 ? _f : false;
        const canUseAsteroids = (_g = options === null || options === void 0 ? void 0 : options.asteroids) !== null && _g !== void 0 ? _g : false;
        const canUsePlants = (_h = options === null || options === void 0 ? void 0 : options.plants) !== null && _h !== void 0 ? _h : (canUseSteel && this.cardIsInEffect(CardName_1.CardName.MARTIAN_LUMBER_CORP));
        const canUseSpireScience = (_j = options === null || options === void 0 ? void 0 : options.spireScience) !== null && _j !== void 0 ? _j : false;
        const availableMegacredits = this.megaCredits - reserveUnits.megacredits;
        if (availableMegacredits < 0)
            return false;
        return cost <=
            availableMegacredits +
                (this.canUseHeatAsMegaCredits ? this.availableHeat - reserveUnits.heat : 0) +
                (canUseSteel ? (this.steel - reserveUnits.steel) * this.getSteelValue() : 0) +
                (canUseTitanium ? (this.titanium - reserveUnits.titanium) * this.getTitaniumValue() : 0) +
                (canUseFloaters ? this.getFloatersCanSpend() * constants_1.DEFAULT_FLOATERS_VALUE : 0) +
                (canUseMicrobes ? this.getMicrobesCanSpend() * constants_1.DEFAULT_MICROBES_VALUE : 0) +
                (canUseGraphene ? this.getSpendableGrapheneResources() * constants_1.DEFAULT_GRAPHENE_VALUE : 0) +
                (canUseAsteroids ? this.getSpendableAsteroidResources() : 0) +
                (canUsePlants ? this.plants * constants_1.DEFAULT_PLANT_VALUE : 0) +
                (canUseSpireScience ? this.getSpendableSpireScienceResources() * constants_1.DEFAULT_SPIRE_SCIENCE_VALUE : 0);
    }
    computeTerraformRatingBump(card) {
        var _a, _b, _c, _d, _e;
        if (!PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.REDS))
            return 0;
        let tr = card.tr;
        if (tr === undefined)
            return 0;
        tr = Object.assign({}, tr);
        let total = 0;
        if (tr.oxygen !== undefined) {
            const availableSteps = constants.MAX_OXYGEN_LEVEL - this.game.getOxygenLevel();
            const steps = Math.min(availableSteps, tr.oxygen);
            total = total + steps;
            if (this.game.getOxygenLevel() < 8 && this.game.getOxygenLevel() + steps >= 8) {
                tr.temperature = ((_a = tr.temperature) !== null && _a !== void 0 ? _a : 0) + 1;
            }
        }
        if (tr.temperature !== undefined) {
            const availableSteps = Math.floor((constants.MAX_TEMPERATURE - this.game.getTemperature()) / 2);
            const steps = Math.min(availableSteps, tr.temperature);
            total = total + steps;
            if (this.game.getTemperature() < 0 && this.game.getTemperature() + (steps * 2) >= 0) {
                tr.oceans = ((_b = tr.oceans) !== null && _b !== void 0 ? _b : 0) + 1;
            }
        }
        if (tr.oceans !== undefined) {
            const availableSteps = this.game.getMaxOceanTilesCount() - this.game.board.getOceansOnBoard();
            const steps = Math.min(availableSteps, tr.oceans);
            total = total + steps;
        }
        if (tr.venus !== undefined) {
            const availableSteps = Math.floor((constants.MAX_VENUS_SCALE - this.game.getVenusScaleLevel()) / 2);
            const steps = Math.min(availableSteps, tr.venus);
            total = total + steps;
            if (this.game.getVenusScaleLevel() < 16 && this.game.getVenusScaleLevel() + (steps * 2) >= 16) {
                tr.tr = ((_c = tr.tr) !== null && _c !== void 0 ? _c : 0) + 1;
            }
        }
        MoonExpansion_1.MoonExpansion.ifMoon(this.game, (moonData) => {
            if (tr.moonColony !== undefined) {
                const availableSteps = constants.MAXIMUM_COLONY_RATE - moonData.colonyRate;
                total = total + Math.min(availableSteps, tr.moonColony);
            }
            if (tr.moonMining !== undefined) {
                const availableSteps = constants.MAXIMUM_MINING_RATE - moonData.miningRate;
                total = total + Math.min(availableSteps, tr.moonMining);
            }
            if (tr.moonLogistics !== undefined) {
                const availableSteps = constants.MAXIMUM_LOGISTICS_RATE - moonData.logisticRate;
                total = total + Math.min(availableSteps, tr.moonLogistics);
            }
        });
        if (this.isCorporation(CardName_1.CardName.PHARMACY_UNION) && card.tags.includes(Tags_1.Tags.SCIENCE)) {
            const pharmacyUnion = this.corporationCards.find((c) => c.name === CardName_1.CardName.PHARMACY_UNION);
            const resourceCount = (_d = pharmacyUnion.resourceCount) !== null && _d !== void 0 ? _d : 0;
            if (resourceCount > 0) {
                const scienceTagCount = card.tags.filter((tag) => tag === Tags_1.Tags.SCIENCE).length;
                const trGainFromPharmacyUnion = Math.min(resourceCount, scienceTagCount);
                total += trGainFromPharmacyUnion;
            }
        }
        total += (_e = tr.tr) !== null && _e !== void 0 ? _e : 0;
        return total;
    }
    getStandardProjects() {
        return new CardLoader_1.CardLoader(this.game.gameOptions)
            .getStandardProjects()
            .filter((card) => {
            if (this.isCorporation(CardName_1.CardName.THORGATE) && card.name === CardName_1.CardName.POWER_PLANT_STANDARD_PROJECT) {
                return false;
            }
            else if (!this.isCorporation(CardName_1.CardName.THORGATE) && card.name === CardName_1.CardName.POWER_PLANT_STANDARD_PROJECT_THORGATE) {
                return false;
            }
            return true;
        })
            .filter((card) => {
            switch (card.name) {
                case CardName_1.CardName.SELL_PATENTS_STANDARD_PROJECT:
                    return false;
                case CardName_1.CardName.BUFFER_GAS_STANDARD_PROJECT:
                    return this.game.isSoloMode() && this.game.gameOptions.soloTR;
                case CardName_1.CardName.AIR_SCRAPPING_STANDARD_PROJECT:
                    return this.game.gameOptions.altVenusBoard === false;
                case CardName_1.CardName.AIR_SCRAPPING_STANDARD_PROJECT_VARIANT:
                    return this.game.gameOptions.altVenusBoard === true;
                case CardName_1.CardName.MOON_COLONY_STANDARD_PROJECT_V2:
                case CardName_1.CardName.MOON_MINE_STANDARD_PROJECT_V2:
                case CardName_1.CardName.MOON_ROAD_STANDARD_PROJECT_V2:
                    return this.game.gameOptions.moonStandardProjectVariant === true;
                default:
                    return true;
            }
            ;
        })
            .sort((a, b) => a.cost - b.cost);
    }
    getStandardProjectOption() {
        const standardProjects = this.getStandardProjects();
        return new SelectCard_1.SelectCard('Standard projects', 'Confirm', standardProjects, (card) => card[0].action(this), { enabled: standardProjects.map((card) => card.canAct(this)) });
    }
    getStandardActionOption() {
        const standardActions = this.getStandardActions();
        return new SelectCard_1.SelectCard('Standard actions', 'Confirm', standardActions, (card) => card[0].action(this), { enabled: standardActions.map((card) => card.canAct(this)) });
    }
    getStandardActions() {
        const standardActions = [];
        const convertPlants = this.isCorporation(CardName_1.CardName.ECOLINE) ? new ConvertPlantsEcoline_1.ConvertPlantsEcoline() : new ConvertPlants_1.ConvertPlants();
        if (convertPlants.canAct(this)) {
            standardActions.push(convertPlants);
        }
        const convertHeat = new ConvertHeat_1.ConvertHeat();
        if (convertHeat.canAct(this)) {
            standardActions.push(convertHeat);
        }
        return standardActions;
    }
    getTurmoilActionOption() {
        const turmoilActions = this.getTurmoilActions();
        return new SelectCard_1.SelectCard('Turmoil actions', 'Confirm', turmoilActions, (card) => card[0].action(this), { enabled: turmoilActions.map((card) => card.canAct(this)) });
    }
    getTurmoilActions() {
        const turmoilActions = [];
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.SCIENTISTS))
            turmoilActions.push(new ScientistsDefaultAction_1.ScientistsDefaultAction());
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.KELVINISTS))
            turmoilActions.push(new KelvinistsDefaultAction_1.KelvinistsDefaultAction());
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.KELVINISTS, TurmoilPolicy_1.TurmoilPolicy.KELVINISTS_POLICY_3)) {
            turmoilActions.push(new KelvinistsPolicy3Action_1.KelvinistsPolicy3Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.GREENS, TurmoilPolicy_1.TurmoilPolicy.GREENS_POLICY_4)) {
            turmoilActions.push(new GreensPolicy4Action_1.GreensPolicy4Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.MARS, TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_POLICY_4)) {
            turmoilActions.push(new MarsFirstPolicy4Action_1.MarsFirstPolicy4Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.UNITY, TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_2)) {
            turmoilActions.push(new UnityPolicy2Action_1.UnityPolicy2Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.UNITY, TurmoilPolicy_1.TurmoilPolicy.UNITY_POLICY_3)) {
            turmoilActions.push(new UnityPolicy3Action_1.UnityPolicy3Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.REDS, TurmoilPolicy_1.TurmoilPolicy.REDS_POLICY_3)) {
            turmoilActions.push(new RedsPolicy3Action_1.RedsPolicy3Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.SPOME, TurmoilPolicy_1.TurmoilPolicy.SPOME_POLICY_2)) {
            turmoilActions.push(new SpomePolicy2Action_1.SpomePolicy2Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.SPOME, TurmoilPolicy_1.TurmoilPolicy.SPOME_POLICY_4)) {
            turmoilActions.push(new SpomePolicy4Action_1.SpomePolicy4Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.EMPOWER, TurmoilPolicy_1.TurmoilPolicy.EMPOWER_DEFAULT_POLICY)) {
            turmoilActions.push(new EmpowerDefaultAction_1.EmpowerDefaultAction());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.BUREAUCRATS, TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_DEFAULT_POLICY)) {
            turmoilActions.push(new BureaucratsDefaultAction_1.BureaucratsDefaultAction());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.BUREAUCRATS, TurmoilPolicy_1.TurmoilPolicy.BUREAUCRATS_POLICY_3)) {
            turmoilActions.push(new BureaucratsPolicy3Action_1.BureaucratsPolicy3Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.POPULISTS, TurmoilPolicy_1.TurmoilPolicy.POPULISTS_POLICY_3)) {
            turmoilActions.push(new PopulistsPolicy3Action_1.PopulistsPolicy3Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.TRANSHUMANS, TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_2)) {
            turmoilActions.push(new TranshumansPolicy2Action_1.TranshumansPolicy2Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.TRANSHUMANS, TurmoilPolicy_1.TurmoilPolicy.TRANSHUMANS_POLICY_3)) {
            turmoilActions.push(new TranshumansPolicy3Action_1.TranshumansPolicy3Action());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.CENTRISTS, TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_DEFAULT_POLICY)) {
            turmoilActions.push(new CentristsDefaultAction_1.CentristsDefaultAction());
        }
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.CENTRISTS, TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_3)) {
            turmoilActions.push(new CentristsPolicy3Action_1.CentristsPolicy3Action());
        }
        MarsCoalition_1.MarsCoalition.addPlayerAction(this, turmoilActions);
        return turmoilActions;
    }
    takeAction() {
        const game = this.game;
        if (game.deferredActions.length > 0) {
            game.deferredActions.runAll(() => this.takeAction());
            return;
        }
        this.howToAffordReds = undefined;
        const allOtherPlayersHavePassed = this.allOtherPlayersHavePassed();
        if (this.actionsTakenThisRound === 0 || game.gameOptions.undoOption) {
            game.save();
        }
        if (this.preludeCardsInHand.length > 0) {
            game.phase = Phase_1.Phase.PRELUDES;
            this.preludeCardsInHand.forEach((card) => {
                Card_1.Card.setUnplayablePreludeWarningText(card, this);
            });
            const playPrelude = this.playPreludeCard();
            if (playPrelude !== undefined) {
                this.setWaitingFor(playPrelude, () => {
                    if (this.preludeCardsInHand.length === 1) {
                        this.takeAction();
                    }
                    else {
                        game.playerIsFinishedTakingActions();
                    }
                });
            }
            else {
                if (this.preludeCardsInHand.length === 1) {
                    this.takeAction();
                }
                else {
                    game.playerIsFinishedTakingActions();
                }
            }
            return;
        }
        else if (game.gameOptions.leadersExpansion === false) {
            game.phase = Phase_1.Phase.ACTION;
        }
        if (this.leaderCardsInHand.length > 0) {
            this.leaderCardsInHand.forEach((card) => {
                if (!this.playedCards.includes(card)) {
                    this.playCard(card);
                }
            });
        }
        else {
            game.phase = Phase_1.Phase.ACTION;
        }
        if (this.isCorporation(CardName_1.CardName.VITOR) && !this.canFundAward() && this.game.gameOptions.automaSoloVariant === false) {
            this.pendingInitialActions = this.pendingInitialActions.filter((card) => card.name !== CardName_1.CardName.VITOR);
        }
        if (game.hasPassedThisActionPhase(this) || (allOtherPlayersHavePassed === false && this.actionsTakenThisRound >= 2)) {
            this.actionsTakenThisRound = 0;
            this.hasTradedThisTurn = false;
            game.playerIsFinishedTakingActions();
            return;
        }
        if (this.pendingInitialActions.length > 0) {
            const orOptions = new OrOptions_1.OrOptions();
            this.pendingInitialActions.forEach((corp) => {
                const option = new SelectOption_1.SelectOption({
                    message: 'Take first action of ${0} corporation',
                    data: [{
                            type: LogMessageDataType_1.LogMessageDataType.RAW_STRING,
                            value: corp.name,
                        }],
                }, corp.initialActionText, () => {
                    game.defer(new DeferredAction_1.DeferredAction(this, () => {
                        if (corp.initialAction) {
                            return corp.initialAction(this);
                        }
                        else {
                            return undefined;
                        }
                    }));
                    this.pendingInitialActions.splice(this.pendingInitialActions.indexOf(corp), 1);
                    return undefined;
                });
                orOptions.options.push(option);
            });
            orOptions.options.push(this.passOption());
            this.performAction(orOptions);
            return;
        }
        ;
        this.performAction(this.getActions());
    }
    performAction(options) {
        this.canUndoLastAction = true;
        this.setWaitingFor(options, () => {
            if (this.pendingInitialActions.length === 0) {
                this.actionsTakenThisRound++;
                this.actionsTakenThisGame++;
            }
            if (this.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE)) {
                this.suitableInfrastructureActive = true;
            }
            this.timer.rebateTime(constants.BONUS_SECONDS_PER_ACTION);
            this.takeAction();
        });
    }
    canAffordMilestone() {
        if (this.canAfford(constants_1.MILESTONE_COST))
            return true;
        if (this.cardIsInEffect(CardName_1.CardName.VAN_ALLEN))
            return true;
        if (this.game.gameOptions.automaSoloVariant)
            return true;
        if (this.isCorporation(CardName_1.CardName.NIRGAL_ENTERPRISES))
            return true;
        return false;
    }
    canClaimMilestone() {
        if (this.game.allMilestonesClaimed())
            return false;
        return true;
    }
    canFundAward() {
        if (this.game.allAwardsFunded())
            return false;
        return true;
    }
    getActions() {
        const action = new OrOptions_1.OrOptions();
        action.title = this.actionsTakenThisRound === 0 ?
            'Take your first action' : 'Take your next action';
        action.buttonLabel = 'Take action';
        const canAffordMilestone = this.canAffordMilestone();
        if (canAffordMilestone && this.canClaimMilestone()) {
            const remainingMilestones = new OrOptions_1.OrOptions();
            remainingMilestones.title = 'Claim a milestone';
            remainingMilestones.options = this.game.milestones
                .filter((milestone) => !this.game.milestoneClaimed(milestone) &&
                milestone.canClaim(this))
                .map((milestone) => this.claimMilestone(milestone));
            if (remainingMilestones.options.length >= 1)
                action.options.push(remainingMilestones);
        }
        const playableStandardActions = this.getStandardActions();
        const standardActionOption = this.getStandardActionOption();
        if (playableStandardActions.length > 0)
            action.options.push(standardActionOption);
        const turmoilActions = this.getTurmoilActions();
        const turmoilActionOption = this.getTurmoilActionOption();
        if (turmoilActions.length > 0)
            action.options.push(turmoilActionOption);
        const playableActionCards = this.getPlayableActionCards();
        const playActionCardOption = this.playActionCard();
        if (playableActionCards.length > 0)
            action.options.push(playActionCardOption);
        if (this.getPlayableCards().length > 0)
            action.options.push(this.playProjectCard());
        if (action.options.includes(playActionCardOption) && playableActionCards.every((card) => card.warning !== undefined)) {
            action.options.push(action.options.splice(action.options.indexOf(playActionCardOption), 1)[0]);
        }
        if (action.options.includes(standardActionOption) && playableStandardActions.every((action) => action.warning !== undefined)) {
            action.options.push(action.options.splice(action.options.indexOf(standardActionOption), 1)[0]);
        }
        const usableTurmoilActions = turmoilActions.filter((ta) => ta.canAct(this));
        if (action.options.includes(turmoilActionOption) && usableTurmoilActions.length === 0) {
            action.options.push(action.options.splice(action.options.indexOf(turmoilActionOption), 1)[0]);
        }
        if (this.game.gameOptions.coloniesExtension) {
            let openColonies = this.game.colonies.filter((colony) => colony.isActive && colony.visitor === undefined);
            const iapetus = openColonies.find((colony) => colony.name === ColonyName_1.ColonyName.IAPETUS);
            if (PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.REDS) && iapetus !== undefined) {
                const tradePosition = iapetus.trackPosition + this.colonyTradeOffset;
                const trGainedFromTrade = iapetus.tradeQuantity[tradePosition];
                if (!this.canAfford(trGainedFromTrade * constants_1.REDS_RULING_POLICY_COST)) {
                    openColonies = openColonies.filter((colony) => colony.name !== ColonyName_1.ColonyName.IAPETUS);
                }
            }
            const canTrade = this.canTrade();
            if (openColonies.length > 0 && this.fleetSize > this.tradesThisGeneration && canTrade) {
                action.options.push(this.tradeWithColony(openColonies));
            }
        }
        Turmoil_1.Turmoil.ifTurmoil(this.game, (turmoil) => {
            let sendDelegate;
            const shouldApplyCentristsTax = PartyHooks_1.PartyHooks.shouldApplyPolicy(this, PartyName_1.PartyName.CENTRISTS, TurmoilPolicy_1.TurmoilPolicy.CENTRISTS_POLICY_2);
            let canAffordLobbyDelegate = true;
            if (shouldApplyCentristsTax && !this.canAfford(2))
                canAffordLobbyDelegate = false;
            let lobbyingCost = 5;
            let inciteLobbyingCost = 3;
            if (shouldApplyCentristsTax) {
                lobbyingCost += 2;
                inciteLobbyingCost += 2;
            }
            if (turmoil.lobby.has(this.id) && canAffordLobbyDelegate) {
                sendDelegate = new SendDelegateToArea_1.SendDelegateToArea(this, 'Send a delegate in an area (from lobby)');
                if (shouldApplyCentristsTax) {
                    sendDelegate = new SendDelegateToArea_1.SendDelegateToArea(this, 'Send a delegate in an area from lobby (2 M€)', { cost: 2 });
                }
            }
            else if (this.isCorporation(CardName_1.CardName.INCITE) && this.canAfford(inciteLobbyingCost) && turmoil.getDelegatesInReserve(this.id) > 0) {
                sendDelegate = new SendDelegateToArea_1.SendDelegateToArea(this, 'Send a delegate in an area (' + inciteLobbyingCost + ' M€)', { cost: inciteLobbyingCost });
            }
            else if (this.canAfford(lobbyingCost) && turmoil.getDelegatesInReserve(this.id) > 0) {
                sendDelegate = new SendDelegateToArea_1.SendDelegateToArea(this, 'Send a delegate in an area (' + lobbyingCost + ' M€)', { cost: lobbyingCost });
            }
            if (sendDelegate) {
                const input = sendDelegate.execute();
                if (input !== undefined) {
                    action.options.push(input);
                }
            }
        });
        if (LeadersExpansion_1.LeadersExpansion.leaderActionIsUsable(this)) {
            action.options.push(this.useLeaderAction());
        }
        if (!this.game.isSoloMode() && this.actionsTakenThisRound > 0 && this.allOtherPlayersHavePassed() === false) {
            if (!this.game.gameOptions.fastModeOption) {
                action.options.push(this.endTurnOption());
            }
            else if (this.game.gameOptions.fastModeOption && this.remainingStallActionsCount > 0) {
                action.options.push(this.stallOption());
            }
        }
        if (this.canAfford(this.game.getAwardFundingCost(this)) && this.canFundAward()) {
            const remainingAwards = new OrOptions_1.OrOptions();
            remainingAwards.title = 'Fund an award';
            remainingAwards.buttonLabel = 'Confirm';
            remainingAwards.options = this.game.awards
                .filter((award) => this.game.hasBeenFunded(award) === false)
                .map((award) => this.fundAward(award));
            if (remainingAwards.options.length >= 1)
                action.options.push(remainingAwards);
        }
        action.options.push(this.getStandardProjectOption());
        action.options.push(this.passOption());
        const sellPatents = new SellPatentsStandardProject_1.SellPatentsStandardProject();
        if (sellPatents.canAct(this)) {
            action.options.push(sellPatents.action(this));
        }
        if (this.actionsTakenThisRound > 0 && this.game.gameOptions.undoOption && this.canUndoLastAction) {
            action.options.push(new UndoActionOption_1.UndoActionOption());
        }
        if (!this.game.isSoloMode() && this.game.generation > 4 && this.game.getPlayersStillInGame().length > 1) {
            action.options.push(this.concedeOption());
        }
        return action;
    }
    canTrade() {
        if (this.game.gameOptions.singleTradeVariant && this.hasTradedThisTurn && !this.allOtherPlayersHavePassed())
            return false;
        if (this.canAfford(this.getMcTradeCost()))
            return true;
        if (this.energy >= this.getEnergyTradeCost())
            return true;
        if (this.titanium >= this.getTitaniumTradeCost())
            return true;
        const titanFloatingLaunchPad = this.playedCards.find((card) => card.name === CardName_1.CardName.TITAN_FLOATING_LAUNCHPAD);
        if (titanFloatingLaunchPad !== undefined && titanFloatingLaunchPad.resourceCount > 0) {
            return true;
        }
        const darksideSmugglersUnion = this.playedCards.find((card) => card.name === CardName_1.CardName.DARKSIDE_SMUGGLERS_UNION);
        if (darksideSmugglersUnion !== undefined && darksideSmugglersUnion.canAct(this) && !this.actionsThisGeneration.has(darksideSmugglersUnion.name)) {
            return true;
        }
        return false;
    }
    allOtherPlayersHavePassed() {
        const game = this.game;
        if (game.isSoloMode())
            return true;
        const players = game.getPlayers();
        const passedPlayers = game.getPassedPlayers();
        return passedPlayers.length === players.length - 1 && passedPlayers.includes(this.color) === false;
    }
    process(input) {
        if (this.waitingFor === undefined || this.waitingForCb === undefined) {
            throw new Error('Not waiting for anything');
        }
        const waitingFor = this.waitingFor;
        const waitingForCb = this.waitingForCb;
        this.waitingFor = undefined;
        this.waitingForCb = undefined;
        try {
            this.timer.stop();
            this.runInput(input, waitingFor);
            waitingForCb();
        }
        catch (err) {
            this.setWaitingFor(waitingFor, waitingForCb);
            throw err;
        }
    }
    getWaitingFor() {
        return this.waitingFor;
    }
    setWaitingFor(input, cb = () => { }) {
        var _a;
        if (this.waitingFor !== undefined) {
            console.error('Overwriting a waitingFor: ' + this.waitingFor);
        }
        if (input instanceof SelectSpace_1.SelectSpace && this.howToAffordReds !== undefined && this.howToAffordReds.spaces !== undefined) {
            let availableSpaces = Array.from(this.howToAffordReds.spaces.keys());
            const spendableMegacredits = this.spendableMegacredits();
            if (spendableMegacredits >= 0) {
                if (spendableMegacredits >= this.howToAffordReds.redTaxes && availableSpaces.every((space) => space.spaceType === SpaceType_1.SpaceType.OCEAN)) {
                    if (((_a = this.lastCardPlayed) === null || _a === void 0 ? void 0 : _a.name) !== CardName_1.CardName.FRONTIER_TOWN) {
                        availableSpaces = this.game.board.getAvailableSpacesForOcean(this);
                    }
                }
                else if (spendableMegacredits < this.howToAffordReds.redTaxes) {
                    const oceanTileTypes = [TileType_1.TileType.OCEAN, TileType_1.TileType.OCEAN_CITY, TileType_1.TileType.OCEAN_FARM, TileType_1.TileType.OCEAN_SANCTUARY, TileType_1.TileType.NEW_HOLLAND];
                    availableSpaces = availableSpaces.filter((space) => {
                        const adjacentOceans = this.game.board.getAdjacentSpaces(space).filter((s) => s.tile !== undefined && oceanTileTypes.includes(s.tile.tileType));
                        let finalPlacementBonus = adjacentOceans.length * this.oceanBonus;
                        if (this.isCorporation(CardName_1.CardName.ARCADIAN_COMMUNITIES) && space.player === this) {
                            finalPlacementBonus += 3;
                        }
                        return finalPlacementBonus + spendableMegacredits >= this.howToAffordReds.redTaxes;
                    });
                }
            }
            if (availableSpaces.some(space => input.availableSpaces.includes(space))) {
                input.title += " (Adjusted for Reds policy)";
                input.availableSpaces = availableSpaces.filter((s) => input.availableSpaces.includes(s));
            }
            else {
                this.howToAffordReds = undefined;
            }
        }
        this.timer.start();
        this.waitingFor = input;
        this.waitingForCb = cb;
    }
    setWaitingForSafely(input, cb = () => { }) {
        if (this.waitingFor === undefined) {
            this.setWaitingFor(input, cb);
        }
        else {
            const oldcb = this.waitingForCb;
            this.waitingForCb =
                oldcb === undefined ?
                    cb :
                    () => {
                        oldcb();
                        this.setWaitingForSafely(input, cb);
                    };
        }
    }
    serializePlayedCards() {
        return this.playedCards.map((c) => {
            const result = {
                name: c.name,
            };
            if (c.bonusResource !== undefined) {
                result.bonusResource = c.bonusResource;
            }
            if (c.resourceCount !== undefined) {
                result.resourceCount = c.resourceCount;
            }
            if (c.target !== undefined) {
                result.target = c.target;
            }
            if (c.isDisabled !== undefined) {
                result.isDisabled = c.isDisabled;
            }
            if (c.opgActionIsActive !== undefined) {
                result.opgActionIsActive = c.opgActionIsActive;
            }
            if (c.effectTriggerCount !== undefined) {
                result.effectTriggerCount = c.effectTriggerCount;
            }
            if (c.generationUsed !== undefined) {
                result.generationUsed = c.generationUsed;
            }
            if (c instanceof SelfReplicatingRobots_1.SelfReplicatingRobots) {
                result.targetCards = c.targetCards.map((t) => {
                    return {
                        card: { name: t.card.name },
                        resourceCount: t.resourceCount,
                    };
                });
            }
            return result;
        });
    }
    serialize() {
        var _a;
        const result = {
            id: this.id,
            password: this.password,
            corporationCards: this.corporationCards.map((c) => {
                const data = {
                    name: c.name,
                    resourceCount: c.resourceCount,
                    allTags: c instanceof Aridor_1.Aridor ? Array.from(c.allTags) : [],
                    isDisabled: c instanceof PharmacyUnion_1.PharmacyUnion && c.isDisabled,
                };
                return data;
            }),
            pickedCorporationCard: (_a = this.pickedCorporationCard) === null || _a === void 0 ? void 0 : _a.name,
            terraformRating: this.terraformRating,
            hasIncreasedTerraformRatingThisGeneration: this.hasIncreasedTerraformRatingThisGeneration,
            terraformRatingAtGenerationStart: this.terraformRatingAtGenerationStart,
            megaCredits: this.megaCredits,
            megaCreditProduction: this.megaCreditProduction,
            steel: this.steel,
            steelProduction: this.steelProduction,
            titanium: this.titanium,
            titaniumProduction: this.titaniumProduction,
            plants: this.plants,
            plantProduction: this.plantProduction,
            energy: this.energy,
            energyProduction: this.energyProduction,
            heat: this.heat,
            heatProduction: this.heatProduction,
            titaniumValue: this.titaniumValue,
            steelValue: this.steelValue,
            canUseHeatAsMegaCredits: this.canUseHeatAsMegaCredits,
            actionsTakenThisRound: this.actionsTakenThisRound,
            actionsThisGeneration: Array.from(this.actionsThisGeneration),
            pendingInitialActions: this.pendingInitialActions.map((c) => c.name),
            remainingStallActionsCount: this.remainingStallActionsCount,
            dealtCorporationCards: this.dealtCorporationCards.map((c) => c.name),
            dealtProjectCards: this.dealtProjectCards.map((c) => c.name),
            dealtPreludeCards: this.dealtPreludeCards.map((c) => c.name),
            dealtLeaderCards: this.dealtLeaderCards.map((c) => c.name),
            cardsInHand: this.cardsInHand.map((c) => c.name),
            preludeCardsInHand: this.preludeCardsInHand.map((c) => c.name),
            leaderCardsInHand: this.leaderCardsInHand.map((c) => c.name),
            playedCards: this.serializePlayedCards(),
            draftedCards: this.draftedCards.map((c) => c.name),
            cardCost: this.cardCost,
            needsToDraft: this.needsToDraft,
            cardDiscount: this.cardDiscount,
            canUndoLastAction: this.canUndoLastAction,
            fleetSize: this.fleetSize,
            tradesThisGeneration: this.tradesThisGeneration,
            hasTradedThisTurn: this.hasTradedThisTurn,
            colonyTradeOffset: this.colonyTradeOffset,
            colonyTradeDiscount: this.colonyTradeDiscount,
            colonyVictoryPoints: this.colonyVictoryPoints,
            hasBureaucratsColonyTradePenalty: this.hasBureaucratsColonyTradePenalty,
            hasTranshumansColonyTradeOffset: this.hasTranshumansColonyTradeOffset,
            turmoilPolicyActionUsed: this.turmoilPolicyActionUsed,
            politicalAgendasActionUsedCount: this.politicalAgendasActionUsedCount,
            dominantPartyActionUsedCount: this.dominantPartyActionUsedCount,
            hasTurmoilScienceTagBonus: this.hasTurmoilScienceTagBonus,
            oceanBonus: this.oceanBonus,
            scienceTagCount: this.scienceTagCount,
            plantsNeededForGreenery: this.plantsNeededForGreenery,
            removingPlayers: this.removingPlayers,
            removedFromPlayCards: this.removedFromPlayCards.map((c) => c.name),
            heatProductionStepsIncreasedThisGeneration: this.heatProductionStepsIncreasedThisGeneration,
            requirementsBonus: this.requirementsBonus,
            hasUsedHeadStart: this.hasUsedHeadStart,
            consecutiveFirstPassCount: this.consecutiveFirstPassCount,
            hazardsRemoved: this.hazardsRemoved,
            oceansPlaced: this.oceansPlaced,
            preservationProgramActive: this.preservationProgramActive,
            suitableInfrastructureActive: this.suitableInfrastructureActive,
            temperatureStepsRaised: this.temperatureStepsRaised,
            name: this.name,
            color: this.color,
            beginner: this.beginner,
            handicap: this.handicap,
            timer: this.timer.serialize(),
            hasConceded: this.hasConceded,
            totalSpend: this.totalSpend,
            endGenerationScores: this.endGenerationScores,
            actionsTakenThisGame: this.actionsTakenThisGame,
            totalDelegatesPlaced: this.totalDelegatesPlaced,
            totalChairmanshipsWon: this.totalChairmanshipsWon,
        };
        if (this.lastCardPlayed !== undefined) {
            result.lastCardPlayed = this.lastCardPlayed.name;
        }
        return result;
    }
    static deserialize(d) {
        const player = new Player(d.name, d.color, d.beginner, Number(d.handicap), d.id);
        const cardFinder = new CardFinder_1.CardFinder();
        player.actionsTakenThisGame = d.actionsTakenThisGame;
        player.actionsTakenThisRound = d.actionsTakenThisRound;
        player.canUndoLastAction = d.canUndoLastAction;
        player.canUseHeatAsMegaCredits = d.canUseHeatAsMegaCredits;
        player.cardCost = d.cardCost;
        player.cardDiscount = d.cardDiscount;
        player.colonyTradeDiscount = d.colonyTradeDiscount;
        player.colonyTradeOffset = d.colonyTradeOffset;
        player.colonyVictoryPoints = d.colonyVictoryPoints;
        player.consecutiveFirstPassCount = d.consecutiveFirstPassCount;
        player.pendingInitialActions = cardFinder.corporationCardsFromJSON(d.pendingInitialActions);
        player.endGenerationScores = d.endGenerationScores;
        player.energy = d.energy;
        player.energyProduction = d.energyProduction;
        player.fleetSize = d.fleetSize;
        player.hasConceded = d.hasConceded;
        player.hasIncreasedTerraformRatingThisGeneration = d.hasIncreasedTerraformRatingThisGeneration;
        player.hasTurmoilScienceTagBonus = d.hasTurmoilScienceTagBonus;
        player.hasBureaucratsColonyTradePenalty = d.hasBureaucratsColonyTradePenalty;
        player.hasTranshumansColonyTradeOffset = d.hasTranshumansColonyTradeOffset;
        player.hasUsedHeadStart = d.hasUsedHeadStart;
        player.hazardsRemoved = d.hazardsRemoved;
        player.heat = d.heat;
        player.heatProduction = d.heatProduction;
        player.heatProductionStepsIncreasedThisGeneration = d.heatProductionStepsIncreasedThisGeneration;
        player.megaCreditProduction = d.megaCreditProduction;
        player.megaCredits = d.megaCredits;
        player.needsToDraft = d.needsToDraft;
        player.oceanBonus = d.oceanBonus;
        player.oceansPlaced = d.oceansPlaced;
        player.password = d.password;
        player.plantProduction = d.plantProduction;
        player.plants = d.plants;
        player.plantsNeededForGreenery = d.plantsNeededForGreenery;
        player.preservationProgramActive = d.preservationProgramActive;
        player.remainingStallActionsCount = d.remainingStallActionsCount;
        player.removingPlayers = d.removingPlayers;
        player.requirementsBonus = d.requirementsBonus;
        player.scienceTagCount = d.scienceTagCount;
        player.steel = d.steel;
        player.steelProduction = d.steelProduction;
        player.steelValue = d.steelValue;
        player.suitableInfrastructureActive = d.suitableInfrastructureActive;
        player.temperatureStepsRaised = d.temperatureStepsRaised;
        player.terraformRating = d.terraformRating;
        player.terraformRatingAtGenerationStart = d.terraformRatingAtGenerationStart;
        player.titanium = d.titanium;
        player.titaniumProduction = d.titaniumProduction;
        player.titaniumValue = d.titaniumValue;
        player.totalDelegatesPlaced = d.totalDelegatesPlaced;
        player.totalChairmanshipsWon = d.totalChairmanshipsWon;
        player.tradesThisGeneration = d.tradesThisGeneration;
        player.hasTradedThisTurn = d.hasTradedThisTurn;
        player.turmoilPolicyActionUsed = d.turmoilPolicyActionUsed;
        player.politicalAgendasActionUsedCount = d.politicalAgendasActionUsedCount;
        player.dominantPartyActionUsedCount = d.dominantPartyActionUsedCount;
        player.lastCardPlayed = d.lastCardPlayed !== undefined ?
            cardFinder.getProjectCardByName(d.lastCardPlayed) :
            undefined;
        player.removedFromPlayCards = cardFinder.cardsFromJSON(d.removedFromPlayCards);
        player.actionsThisGeneration = new Set(d.actionsThisGeneration);
        if (d.pickedCorporationCard !== undefined) {
            player.pickedCorporationCard = cardFinder.getCorporationCardByName(d.pickedCorporationCard);
        }
        if (d.corporationCards.length > 0) {
            const playerCorps = [];
            d.corporationCards.forEach((corp) => {
                const corpCard = cardFinder.getCorporationCardByName(corp.name);
                if (corpCard !== undefined) {
                    if (corpCard.resourceCount !== undefined) {
                        corpCard.resourceCount = corp.resourceCount;
                    }
                }
                if (corpCard instanceof Aridor_1.Aridor) {
                    if (corp.allTags !== undefined) {
                        corpCard.allTags = new Set(corp.allTags);
                    }
                    else {
                        console.warn('did not find allTags for ARIDOR');
                    }
                }
                if (corpCard instanceof PharmacyUnion_1.PharmacyUnion) {
                    corpCard.isDisabled = Boolean(corp.isDisabled);
                }
                playerCorps.push(corpCard);
            });
            player.corporationCards = playerCorps;
        }
        else {
            player.corporationCards = [];
        }
        player.dealtCorporationCards = cardFinder.corporationCardsFromJSON(d.dealtCorporationCards);
        player.dealtPreludeCards = cardFinder.cardsFromJSON(d.dealtPreludeCards);
        player.dealtLeaderCards = cardFinder.cardsFromJSON(d.dealtLeaderCards);
        player.dealtProjectCards = cardFinder.cardsFromJSON(d.dealtProjectCards);
        player.cardsInHand = cardFinder.cardsFromJSON(d.cardsInHand);
        player.preludeCardsInHand = cardFinder.cardsFromJSON(d.preludeCardsInHand);
        player.leaderCardsInHand = cardFinder.cardsFromJSON(d.leaderCardsInHand);
        player.playedCards = d.playedCards.map((element) => {
            const card = cardFinder.getProjectCardByName(element.name);
            if (element.resourceCount !== undefined) {
                card.resourceCount = element.resourceCount;
            }
            if (element.target !== undefined) {
                card.target = element.target;
            }
            if (element.isDisabled !== undefined) {
                card.isDisabled = Boolean(element.isDisabled);
            }
            if (element.opgActionIsActive !== undefined) {
                card.opgActionIsActive = Boolean(element.opgActionIsActive);
            }
            if (element.effectTriggerCount !== undefined) {
                card.effectTriggerCount = Number(element.effectTriggerCount);
            }
            if (element.generationUsed !== undefined) {
                card.generationUsed = Number(element.generationUsed);
            }
            if (card instanceof SelfReplicatingRobots_1.SelfReplicatingRobots && element.targetCards !== undefined) {
                card.targetCards = [];
                element.targetCards.forEach((targetCard) => {
                    const foundTargetCard = cardFinder.getProjectCardByName(targetCard.card.name);
                    if (foundTargetCard !== undefined) {
                        card.targetCards.push({
                            card: foundTargetCard,
                            resourceCount: targetCard.resourceCount,
                        });
                    }
                    else {
                        console.warn('did not find card for SelfReplicatingRobots', targetCard);
                    }
                });
            }
            if (card instanceof MiningCard_1.MiningCard && element.bonusResource !== undefined) {
                card.bonusResource = element.bonusResource;
            }
            return card;
        });
        player.draftedCards = cardFinder.cardsFromJSON(d.draftedCards);
        player.timer = Timer_1.Timer.deserialize(d.timer);
        return player;
    }
    getFleetSize() {
        return this.fleetSize;
    }
    increaseFleetSize() {
        if (this.fleetSize < constants_1.MAX_FLEET_SIZE)
            this.fleetSize++;
    }
    decreaseFleetSize() {
        if (this.fleetSize > 0)
            this.fleetSize--;
    }
    hasAvailableColonyTileToBuildOn() {
        if (this.game.gameOptions.coloniesExtension === false)
            return false;
        const availableColonyTiles = this.game.colonies.filter((colony) => colony.isActive);
        let colonyTilesAlreadyBuiltOn = 0;
        availableColonyTiles.forEach((colony) => {
            if (colony.colonies.includes(this.id))
                colonyTilesAlreadyBuiltOn++;
        });
        return colonyTilesAlreadyBuiltOn < availableColonyTiles.length;
    }
    canUseSingleTurmoilAction(isDominantPartyAction) {
        if (isDominantPartyAction)
            return this.dominantPartyActionUsedCount === 0;
        return this.turmoilPolicyActionUsed === false;
    }
    canUseTripleTurmoilAction(isDominantPartyAction) {
        if (isDominantPartyAction)
            return this.dominantPartyActionUsedCount < constants_1.POLITICAL_AGENDAS_MAX_ACTION_USES;
        return this.politicalAgendasActionUsedCount < constants_1.POLITICAL_AGENDAS_MAX_ACTION_USES;
    }
    defer(input, priority) {
        if (input === undefined)
            return;
        const action = new DeferredAction_1.DeferredAction(this, () => input, priority);
        this.game.defer(action);
    }
    willGainHeatProductionFromTemperatureIncrease(steps) {
        const currentTemperature = this.game.getTemperature();
        if (currentTemperature >= -20)
            return false;
        if (currentTemperature < -24 && currentTemperature + steps * 2 >= -24 && this.game.gameOptions.automaSoloVariant === false) {
            return true;
        }
        if (currentTemperature < -20 && currentTemperature + steps * 2 >= -20) {
            return true;
        }
        return false;
    }
    willGainHeatProductionFromOxygenIncrease(steps) {
        const currentOxygenLevel = this.game.getOxygenLevel();
        if (currentOxygenLevel >= 8 || currentOxygenLevel < 6)
            return false;
        if (currentOxygenLevel + steps >= 8) {
            return this.willGainHeatProductionFromTemperatureIncrease(1);
        }
        return false;
    }
    willGainProductionFromMoonTrackIncrease(tr) {
        var _a, _b, _c;
        if (tr.moonColony !== undefined) {
            const currentMoonColonyRate = (_a = this.game.moonData) === null || _a === void 0 ? void 0 : _a.colonyRate;
            if (currentMoonColonyRate < 6 && currentMoonColonyRate + tr.moonColony >= 6)
                return true;
        }
        if (tr.moonLogistics !== undefined) {
            const currentMoonLogisticsRate = (_b = this.game.moonData) === null || _b === void 0 ? void 0 : _b.logisticRate;
            if (currentMoonLogisticsRate < 6 && currentMoonLogisticsRate + tr.moonLogistics >= 6)
                return true;
        }
        if (tr.moonMining !== undefined) {
            const currentMoonMiningRate = (_c = this.game.moonData) === null || _c === void 0 ? void 0 : _c.miningRate;
            if (currentMoonMiningRate < 6 && currentMoonMiningRate + tr.moonMining >= 6)
                return true;
        }
        return false;
    }
}
exports.Player = Player;
//# sourceMappingURL=Player.js.map